var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRs(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 40,
    fill: "none",
    viewBox: "0 0 54 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    width: 54,
    height: 40,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.3 0h53.4v40H.3z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-2.3 0h60v40h-60z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0c4076",
    d: "M-2.3 0h60v26.7h-60z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c6363c",
    d: "M-2.3 0h60v13.3h-60z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "M14.7 11.8h.8l.2-.1h1.8l.1-.1h1-1.5l-.2.1h-1.7l-.2.1h-.5m.2 1.4-.3-1.4zM19 13h-.5l-.1.1h-2.9l-.2.1h-.5 1.9l.2-.1zm4.2.2H20l-.2-.1H19zm.3-1.4-.3 1.4zm-4.2-.2h3l.2.1h1v.1H22l-.1-.1H20v-.1h-.4m-.3 0h.4zm-.4 0h.4zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#edb92e",
    d: "m23.6 11.8.5-.9q-.8.6-.8-.1h-.1q-.6.9-1.2-.3-.8 1.2-1.3 0-.9 1-1.5 0v-.1H19q-.6 1.2-1.5 0-.5 1.4-1.3 0-.6 1.3-1.1.4h-.2q0 .7-.8.1l.5.9 4.5-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "M24.1 11H24v.1h-.1v.2h-.1v.2h-.1v.1h-.1v-.1h.1v-.2h.1v-.2h.1V11zm-.8-.2v.3h.6l.1-.1h.1-.1l-.1.1h-.2v.1h-.3V11h-.1v-.3m-1.3-.3h.1v.2h.1v.1h.1v.1h.1l.1.1h.3l.1-.1h.1v-.1l.1-.1v.1H23v.1h-.1v.1h-.5l-.1-.1v-.1h-.1v-.1zm-1.3 0 .1.2.1.1v.1h.1v.1h.6v-.1h.1v-.1l.1-.1.1-.1v-.1h.1v.1l-.1.1-.1.1-.1.1-.1.1h-.1v.1H21v-.1h-.1v-.1h-.1v-.2zm-1.5 0v.2h.1v.1h.1v.1h.8v-.1h.1v-.1h.1v-.1h.1v-.2h.1v.2h-.1l-.1.1-.1.1-.1.1h-.1l-.1.1h-.5l-.1-.1-.1-.1-.1-.1zm-.1-.1H19m-1.6 0h.1v.1h.1l.1.1v.1h.1l.1.1h.7v-.1l.1-.1.1-.1v-.1h.1v.1h-.1v.1l-.1.1-.1.1h-.1v.1H18v-.1h-.1l-.1-.1-.1-.1h-.1v-.2zm-1.3.1h.6v-.1l.1-.1.1-.2.1-.2v.5l-.1.1h-.6zm-1.2.3h.6v-.1h.1v-.2h.1v-.2h.1v.3l-.1.1v.1h-.2v.1H15zm-.9.1h.4v-.3h.1v.3h-.1v.1zm.5.9h-.1v-.2h-.1v-.1h-.1v-.2h-.1V11H14h.1v.1l.1.1v.1h.1v.2h.1v.1zm4.5-.3h-.3l-.1.1H17l-.2.1h-2.2 3.1l.1-.1h1.3m4.5.3h-2l-.1-.1h-2l-.1-.1H19h3l.1.1h1.4m0 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#edb92e",
    d: "m18 12.3 1-.5 1.1.5-1 .5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#edb92e",
    d: "m18.7 11.6-4.1.2.3 1.4L19 13h4.2l.3-1.3-4.1-.2h-.8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#edb92e",
    d: "M24.2 10.6H24q-.5 1-.6 0l.1-.1v-.1h-.2q0-.2-.2-.1v.2q-.8 1.2-.7-.3l-.4-.1q-.7 1.4-1.2.2l.2-.2q-.1-.2-.3 0 0-.3-.3-.1l.2.2c-.2 1-1.4 1-1.2-.3h-.6c.2 1.3-1 1.2-1.2.3l.2-.1V10h-.6v.1l.2.1q-.5 1.5-1.2-.1l-.4.1q0 1.4-.8.3v-.1l.1-.1-.2.1h-.3q.2 0 .2.2 0 1-.6 0H14l.2.5q.7.8.8-.2.9 1 1.2-.2c.5 1 1.3.5 1.3 0 .3.8 1.5.8 1.6-.2.1 1 1.4 1 1.6.1 0 .6.8 1.1 1.4.1q.1 1.2 1.1.2 0 1 .9.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "M24 10.5h.2zm-.6 0v.4h.1v.2h.2V11h.1v-.1l.1-.1v-.2h.1v.2h-.1v.1l-.1.1v.1h-.3v-.2h-.1zm.1 0h-.1zm0 0h.1zm-.2 0h.3-.2m-.2-.2h.2v.1-.1zm-.7-.1v.6l.1.1h.3l.1-.1h.1v-.2h.2l-.1.1-.1.1-.1.1h-.1v.1h-.3l-.1-.1zm-.4-.1h.4v.1H22m-1.2.1v.2h.1v.2h.1v.1l.1.1h.4l.1-.1.1-.1v-.1l.1-.1v-.1l.1-.1V10h.1v.2h-.1v.2h-.1v.1h-.1v.1h-.1v.1h-.1v.1H21v-.3zv-.2zm.2-.1h-.1V10zm0 0V10zm-.3 0V10h.3-.3m-.3-.1h.2zm.2.2h-.1V10zm-1.2-.3v.6l.1.1v.1h.1l.1.1h.4l.1-.1h.1v-.1l.1-.1v-.1l.1-.1v.2h-.1v.2h-.1l-.1.1H20v.1h-.4v-.1l-.1-.1-.1-.2zm-.3 0h.2zm-.3 0h.2zm-1.2.3h.6V10l.1-.1.1-.1v-.2.7l-.1.1h-.1v.1H18l-.1-.1-.1-.1-.1-.1zm-.1-.2h.2zm-.3 0h.3zm-1 .2.1.2.1.1.1.2.1.1.1.1h.4v-.1h.1v-.2h.1v-.2h.1v.2h-.1v.1l-.1.1v.1H17v.1h-.4v-.1h-.1v-.1h-.1v-.1l-.1-.1v-.1zm-.4 0h.2l.1-.1h.1zm-.8.3h.3V10v.7H15l-.1-.1zm-.2-.1h.3zm-.2 0h.2zm.2.2h-.1zm-.7 0h.3v-.4h.1v.4h-.1v.1zl-.1-.1zm.1.4H14v-.4.3zm.8-.2v.5h-.1v.1h-.5l-.1-.1-.1-.1V11l.1.1.1.1h.1v.1h.3v-.1h.1v-.4zm1.2 0-.1.1v.1l-.1.1v.1h-.6l-.1-.1-.1-.1-.1-.1-.1-.2v.1l.1.1h.1v.1h.1l.1.1h.1v.1h.4V11l.1-.1v-.3l.1-.1m0 0v-.2zm1.3-.2v.4h-.1l-.1.1v.1H17v.1h-.5l-.1-.1-.1-.1-.1-.1-.1-.2.1.2h.1v.1h.1v.1h.7l.1-.1h.1v-.3zm1.6-.1v.3l-.1.1-.1.1-.1.1h-.1v.1h-.8l-.1-.1-.1-.1-.1-.2v-.1h-.1l.1.1.1.1.1.1.1.1h.1l.1.1h.8v-.2h.1v-.3zm1.6.1-.1.2h-.1v.1h-.1v.1h-.1v.1h-.9v.1h-.1l-.1-.1v-.2H19v-.2.3h.1v.1h.1v.1h.1v.1h.2v.1h.6l.1-.1.1-.1.1-.1v-.2zm1.4.1-.1.2h-.1v.1h-.1v.1h-.8v.1h-.1l-.1-.1v-.2.2h.1v.1l.1.1h.1l.1.1h.6V11h.1l.1-.1zm1.1.2-.1.1v.1h-.1v.1h-.1l-.1.1H22v-.4.4h.1v.1h.1v.1h.4l.1-.1h.1V11h.1zm.8.1v.2h-.1v.1h-.1v.1h-.5V11l-.1-.1v-.2.3h.1v.1h.1v.1h.3l.1-.1V11zm.2-.4v.4H24v-.4zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#edb92e",
    d: "M19 11.7h-2.4l-.8.1-1.2.2q-.4-.2 0-.3l2.8-.2h3.4l2.8.2q.4.2 0 .2h-1.2l-.8-.1h-2.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0c4076",
    d: "M19 4.7a1 1 0 0 1 .9.7 1 1 0 0 1-.8.8 1 1 0 0 1-.8-.7q.1-.8.8-.8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#edb92e",
    d: "M19.2 3.8q.2 0 .2-.2l-.2-.1-.1-.1-.1.1-.2.1a.1.1 0 0 0 .2.2V4h-.3a.1.1 0 0 0-.1-.2q-.2 0-.2.2v.2a.1.1 0 0 0 .2.2l.1-.2h.3v1h.2v-1h.3a.1.1 0 0 0 .1.2q.2 0 .2-.2V4l-.2-.2-.1.2h-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "M19.3 3.6v.2-.1m-.2-.2v.1zm-.1.1v-.1zm-.2.1v-.1h.1zm.2.2h-.1v-.1h-.1m0 .3v-.3zm-.3 0h.3zm-.3.1h-.1zm.3.1v.2h-.1zm.3 0h-.3zm0 1v-1zm.2-1v1zm.3 0H19zm.1.2h-.1v-.1zm.2-.2h-.1v.1m-.6-.2h.3zm.8 1.3v-.2h-.1V5l-.1-.1-.1-.1h-.1v-.1H19v-.1h.4v.1h.1V5h.1l.1.1zm-.8.7h.3V6h.3v-.2h.1v-.3.4l-.1.1-.1.1h-.1v.1H19m-.8-.7.1.1v.1l.1.1.1.1h.1V6h.2v.1h.2-.4l-.1-.1h-.1v-.2h-.1v-.3zm.8-.8h-.3v.1h-.2V5l-.1.1v.1h-.1v.4V5h.1v-.1l.1-.1h.1l.1-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#edb92e",
    d: "M19.8 5.3v.3h-1.5v-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "M19.9 5.5v-.2zm-.8 0h.8zm-.8 0h.8zm0-.2v.2zm.8 0h-.7zm.8 0H19h.7m0 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#edb92e",
    d: "M18.5 6q-.2-.2-.2.1v2q-.1.4 0 .4l.3.4h1l.4-.4-.1-.5V6.1q0-.2-.2-.2a1 1 0 0 1-1.2 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "M18.3 6.1v-.2h.2-.1zm0 2V6zm0 .4h-.1V8h.1zm.3.4h-.1v-.1h-.2v-.1h.1v.1zm.5 0h-.5zm.5 0H19zm.4-.4-.1.1h-.1v.1h-.1v.1-.1h.1v-.1h.1zm-.1-.5h.1v.3V8zm0-1.8v2-1.8m-.2-.2v.2zm-1.2 0h1.2-.3v.1h-.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#edb92e",
    d: "M13.8 9.5v-.7c-.6-.8-.6-.9-.2-1.2l1.7-.7.3-.3c-1 0-2.3.5-2.9 1q-.4.5.6 1.8.4.4.5 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "M13.8 9v.4zm0-.2V9m-.2-1.2V8h-.1v.5l.1.1v.1l.1.1.1.2-.1-.2-.1-.1-.1-.1v-.1l-.1-.1V8h.1v-.1zm1.7-.7L15 7h-.2l-.1.1h-.1l-.1.1h-.2l-.1.1h-.1l-.1.1h-.2v.1h-.2v.1h-.1.1v-.1h.2v-.1h.2v-.1h.3v-.1h.2l.1-.1h.2L15 7zm.3-.3V7zm-2.9 1h.1v-.1h.2v-.1l.2-.1h.1l.1-.1h.1V7h.4l.2-.1h.2v-.1h.4v-.1h.5l.1-.1h.3-.6l-.1.1h-.3l-.1.1h-.2l-.1.1H14l-.1.1h-.1l-.2.1-.2.1h-.1l-.1.1-.1.1H13v.1h-.2zm.6 1.7H13v-.6l-.1-.1-.1-.1v-.2h-.1v-.2h-.1v-.5h.1v.7l.1.2.1.1v.1h.1V9l.1.1zm.5.1h-.4l-.1-.1h.2v.1h.2zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#edb92e",
    d: "M13.6 9.5V9l-.4-.6V8q0-.2.3-.4t.6-.4l1.1-.3-.1.2-1.5.6c-.4.3-.4.4.2 1.2v.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "M13.6 9.3v.2zm0-.3v.3zm-.4-.6v.2h.1v.1h.1V9h.1-.1v-.1h-.1v-.1h-.1v-.2zm-.1-.5v.3h.1v.1-.1H13zm.3-.4H13v-.1h.1v-.1zm.7-.4h-.2v.1h-.2v.1h-.1.1l.1-.1h.1zm1.2-.3h-.4l-.1.1h-.5l-.1.1h.1l.1-.1h.2l.1-.1h.4v-.1zM15 7l.2-.2zm-1.4.7h.2l.1-.1h.1l.1-.1h.1l.1-.1h.2l.1-.1h.2L15 7h-.1v.1h-.3v.1h-.2l-.1.1h-.1l-.1.1H14l-.1.1h-.1l-.1.1zm.2 1.1h-.1v-.1h-.1v-.1l-.1-.1v-.1h-.1v-.2h-.1v-.4h.1v-.1h.1l-.1.1v.5l.1.1v.2h.1zm0 .7V9zm-.2 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#edb92e",
    d: "M18.5 5.9q0-.2 0 0h-.1v.4q-2.3 0-2.6.6t.6 1.6v.1q-.2.2-.1.4a1 1 0 0 1-1 .1l-.2-.2-.1-.1-.5-1.4c-.4-1.4 3.4-1.5 4-1.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "M18.4 6v-.2zm0 .1h-.1v-.2.2m0 .2h-.1v-.1m-2.6.6h.2l.1-.1h.3l.1-.1H18h-1.5l-.1.1h-.3l-.1.1-.1.1h.1V7h-.1zm.6 1.6h-.1v-.1l-.1-.1V8l-.1-.1v-.1l-.1-.1v-.2h-.1V7v.6h.1v.2h.1v.1l.1.2.1.1v.1zm0 .2v-.2zm-.1.4v-.4zm-1 0h.8-.2v.1zm-.8-1.7v.3l.1.1V8h.1v.2l.1.1v.2h.1v.2-.2l-.1-.1v-.2l-.1-.1V8l-.1-.1v-.2l-.1-.1zm4-1.5H17V6h-.6l-.2.1H16l-.2.1h-.2l-.1.1h-.2l-.1.1-.2.1-.2.2-.2.1v.6l-.1-.2v-.3l.1-.1.2-.2.2-.1.1-.1h.2l.1-.1h.2l.2-.1h.2V6h.4l.2-.1h.7l.2-.1zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15.7 8.5q.2 0 .3.3l-.3.2-.3-.2q0-.3.3-.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "m16 8.8-.3-.3.2.1zm-.3.3.2-.2v-.1.2zm-.3-.3.2.2zm.3-.3-.3.1v.2l.1-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m13.3 9 .2.3q0 .3-.2.3a.3.3 0 0 1 0-.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "m13.5 9.3-.1-.2h-.1.2zm-.2.3.2-.1v-.2.3zm-.3-.3.1.3h.2l-.3-.1zm.3-.2-.3.1v.1l.1-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M13 8.6q.3 0 .3.3T13 9l-.3-.2q0-.3.3-.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "m13.3 8.9-.2-.3H13zM13 9l.2-.1v-.1.2zm-.3-.2.2.2h.1-.2zm.3-.3-.2.1V9v-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.8 8.1a.3.3 0 0 1 0 .5.3.3 0 0 1 0-.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "M13 8.4V8h-.1zm-.2.3.2-.2v-.1.2zm-.3-.3.2.2h-.2zm.3-.3q-.2 0-.2.2h-.1l.1-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#edb92e",
    d: "M17.4 9q.2.2.1.3 0 .2-.1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "M17.5 9.3V9zm-.1 0h.1zm0-.3v.3l-.1-.1V9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M17.4 9.2c.4 0 .3.6.2.7q0 .3-.3 0s-.2-.7.1-.7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "M17.6 10v-.8h-.1.1v.2h.1v.5m-.3 0h.3-.2m.1-.8v.7-.1l-.1-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#edb92e",
    d: "M14.5 9.4q.2 0 .2.3h-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "M14.7 9.7v-.2h-.1v-.1.1h.1zm-.1-.3v.3h.1-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M14.6 9.5c.3 0 .4.6.4.7q0 .3-.3.1c-.1 0-.4-.6-.1-.8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "M15 10.2v-.3h-.1v-.2h-.1v-.1h-.2v-.1h.2v.1h.1v.3h.1zm-.4-.7v.5h.1v.2-.1l-.1-.1h-.1v-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#edb92e",
    d: "M18.3 6.1a5 5 0 0 0-2.3.4q-1 .4.2 2L16 9h.2v-.4q.2 0 0-.1-.7-1.1-.6-1.6.4-.7 2.6-.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "m16 6.5.1-.1h.2l.1-.1h.2l.2-.1h1.5-1.7v.1h-.3l-.1.1zm.2 2H16v-.1l-.1-.1-.1-.1V8h-.1v-.2h-.1v-.2l-.1-.1v-1h.1l.1-.1h.1l-.1.1h-.1v.2h-.1v.8l.1.1v.1l.1.2.1.2h.1v.1zm-.1.5v-.4h.1zm.2 0H16zm0-.4V9zm-.6-1.7v.5l.1.1v.1l.1.1V8l.1.2.1.1.1.1v.1l.1.1v.1l-.1-.2-.1-.1V8H16v-.1h-.1v-.2h-.1v-.3h-.1zm2.6-.6h-1.5v.1h-.3l-.1.1h-.2v.1H16v.1h-.1v.1h-.1V7v-.2h.1l.1-.1h.1l.1-.1h.2v-.1h.5l.1-.1h1.3m0-.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M14.6 6.4q.2 0 .2.2t-.2.3a.3.3 0 0 1-.2-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "m14.9 6.6-.2-.2h-.1.2zm-.3.3.2-.2v.2zm-.3-.3.2.3-.2-.1zm.3-.3-.2.2v.1h-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15.1 6.2q.3 0 .3.3a.3.3 0 0 1-.5.1v-.1q0-.3.2-.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "M15.4 6.5q0-.2-.2-.3h.2zm-.3.3.2-.2v-.1h.1l-.1.2zm-.3-.3.2.2h.1-.2zm.3-.3-.2.1v.2-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#edb92e",
    d: "M15.2 6.4q-.6.4-.5.8l.4 1.4.5.4q0 .2-.2.1l-.3-.3-.1-.1-.5-1.4q0-.7.7-1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "M14.7 7.3v-.4h.1v-.1h.1v-.1h.1v-.1h.2-.1v.1h-.2v.1h-.1V7l-.1.1zm.4 1.4v-.2l-.1-.1V8h-.1v-.3h-.1v-.4h-.1v-.1.2h.1v.3l.1.1v.3l.1.1v.2zm.3.5h.2zm-.3-.3v.2zm-.1 0v-.1m-.5-1.5v.3l.1.1V8h.1v.2l.1.1v.2l.1.1v.1-.2l-.1-.1v-.2h-.1V8h-.1v-.3h-.1v-.3m.7-1H15l-.1.1h-.1v.1h-.1v.1l-.1.1v.4h-.1v-.4h.1v-.1l.1-.1h.1v-.1h.1l.1-.1zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#edb92e",
    d: "M13.5 9.7H13z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "M13.1 9.8h.3zm.4-.1h-.3v.1-.1zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#edb92e",
    d: "M13.5 9.5h.2q.3-.1.1.2v.3q.2.1 0 .2-.4 0-.4-.4c0-.2-.3-.2 0-.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "M13.9 9.7v-.2h-.1.1zm0 .3v-.2zm-.5-.6v.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#edb92e",
    d: "M13.5 9.5h.3q0 .3-.3.2H13q.1-.4.5-.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "M13.8 9.5h-.2zm-.3.2v-.2h.1zh-.3m-.3 0h.2zm.4-.2H13v.2-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18 5.5q.3 0 .3.3t-.2.3l-.3-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "m18.4 5.8-.2-.2H18h.2zm-.3.3.2-.2zm-.3-.3q0 .2.2.2v.1l-.2-.1zm.3-.3-.3.2v.1l.1-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m17.5 5.5.3.3q0 .3-.3.3l-.3-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "m17.8 5.8-.2-.2h-.1.3zm-.3.3.2-.2h.1l-.1.2zm-.3-.3.2.2h.1v.1l-.2-.1zm.3-.3-.2.2v.1-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m17 5.6.2.3q0 .2-.3.2l-.2-.2q0-.3.2-.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "m17.2 5.9-.1-.3h-.2l.3.1zm-.3.3.3-.2v-.1.2zm-.2-.3.1.2h.1-.2zm.2-.3-.2.1V6l.1-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16.4 5.7a.3.3 0 0 1 0 .5l-.2-.2q0-.3.2-.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "m16.7 6-.2-.3.2.1zm-.3.3.3-.2V6zm-.3-.3.2.2h.1-.2zm.3-.3-.2.1V6v-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m13 7.1.3.3q0 .2-.2.3l-.3-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "m13.4 7.4-.2-.2H13V7l.2.1zm-.3.3.2-.2v-.1.2zm-.3-.3.1.2h.2-.3zM13 7l-.3.2.1-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M13.5 6.8q.3 0 .3.3t-.3.3l-.2-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "m13.8 7-.2-.1v-.1zm-.3.4.3-.3-.1.2zm-.3-.3.2.2h.1-.2zm.3-.3-.2.2v-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M14 6.5q.3 0 .3.3t-.2.3l-.3-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "m14.4 6.8-.2-.2H14h.2zm-.3.3.2-.1v-.2.3zm-.3-.3.3.3-.3-.1zm.3-.3-.3.2v.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m12.7 7.6.2.1v.1q0 .3-.2.3l-.3-.3q0-.2.3-.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "m13 7.8-.2-.2h-.1.2zm-.3.3.2-.1v-.2zm-.3-.3.2.3h.1l-.3-.1zm.3-.3-.2.2v.1h-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#edb92e",
    d: "m17.9 12.3-1 .6-1-.5 1-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "m16.8 11.9-1 .6zm1 .4-1-.4zm0 0h.1m-1 .6 1-.6zm-1-.5 1 .5zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c6363c",
    d: "M16.8 12q.5 0 .5.3t-.4.4-.5-.3.4-.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "m17.3 12.4-.1-.1H17l-.1-.1h.3v.1zm-.4.3h.1l.1-.1h.1v-.2h.1v.1h-.1v.1H17zm-.5-.3h.1v.1h.3zm.4-.4h-.2v.1h-.1v.2h-.1v-.2h.1V12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#edb92e",
    d: "m14.7 12 1 .4-.9.6c-.2 0-.4-.8-.1-1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "m15.7 12.5-1-.4zm-.9.5 1-.6zm-.1-1v.7h.1v.1h.1v.1h-.1v-.2h-.1zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0c4076",
    d: "M14.7 12.2q.3 0 .5.3 0 .3-.5.3-.2 0-.2-.2t.2-.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "M15.2 12.5H15v-.1h-.3zm-.5.4h.2v-.1h.1v-.2.3zm-.3-.3h-.2zm.3-.4v.2h-.1v.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m18 12.5.1.1-.1.2-.1-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "M18.2 12.6H18v-.1zm-.2.2v-.1h.1zm-.2-.2h.2v.1zm.2-.1h-.1v.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15.8 12.6q.2 0 .2.2l-.2.1-.1-.1zm0-.6a.1.1 0 0 1-.2 0q0-.2.2-.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "M15.8 12.3V12h.1zm-.2-.2h.1m.2-.2v.2h-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m18 11.9.1.1-.1.2a.1.1 0 0 1-.2-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "M18.2 12H18zm-.2.2V12h.1zm0-.3h-.1v.1-.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#edb92e",
    d: "m14.2 10.6.3.2q0-.3-.3-.7l-.1-.4-.2.1v.3q.3.3.3.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "M14.4 10.8h-.2v-.1zm-.2-.7h.1v.1l.1.1v.3h.1v.2-.3h-.1v-.2h-.1v-.1zm-.2-.4v.1h.1v.2h.1-.1v-.2m0 .4v-.3zm.1.5v-.3H14v-.1h.1zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#edb92e",
    d: "M14 9.7v.3l.2.1.1.2v.2l.2.3v-.6l-.2-.2-.2-.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "M14.2 10.1H14m.1.2v-.1H14m0 .2v-.2zm.2.3v-.4zm-.4-1h.2v.1zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#edb92e",
    d: "M13.7 10.1h.2c.3 0 .4.5.1.6l-.1-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "M14 10.7V10h.1v.1h.1v.5zm-.3-.4v.2zm0-.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#edb92e",
    d: "M13.8 10.2c.2-.1.4.3.2.4l-.2-.2q-.2-.1 0-.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "M14 10.6v-.4h-.2.2v.2h.1zm-.2-.5v.3-.1h-.1v-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0c4076",
    d: "M13.8 10.2q.3 0 .2.3h-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "M14 10.5v-.2h-.1.1zm-.2-.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15.4 8q.3 0 .3.3t-.3.3l-.2-.3q0-.3.3-.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "m15.8 8.3-.2-.2h-.2V8l.3.1zm-.4.3.3-.3-.1.3zm-.3-.3.2.2h.1v.1l-.2-.1zm.4-.3-.3.2V8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15.2 7.5q.3 0 .3.3t-.3.3l-.2-.3q0-.2.2-.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "m15.5 7.8-.1-.2h-.2.3zm-.3.3q.2 0 .3-.2l-.1.2zm-.3-.3.2.3h.1zm.3-.3-.2.2v.1-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m16 5.9.2.2q0 .3-.3.3a.3.3 0 0 1-.2-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "m16.2 6.1-.2-.2h.2zm-.3.3q.2 0 .2-.2h.1l-.1.2zm-.3-.3.2.3h.1l-.2-.1zm.3-.3-.2.2v.1V6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15.5 6a.3.3 0 0 1 0 .6l-.3-.2q0-.3.3-.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "m15.8 6.4-.2-.3h-.1.2zm-.3.3.2-.2v-.1.2zm-.3-.3.1.2h.2-.3zm.3-.4-.3.2v.1l.1-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15.1 6.5q.3 0 .3.3a.3.3 0 1 1-.6 0q0-.3.3-.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "m15.4 6.8-.2-.3zm-.3.3.3-.2v-.1l-.1.2zm-.3-.3.2.2h.1-.2zm.3-.4a.3.3 0 0 0-.2.4.3.3 0 0 1 .2-.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15 7q.3 0 .4.3l-.3.3-.3-.3q0-.3.3-.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "m15.4 7.3-.2-.3H15l.2.1zm-.3.3.2-.3v.2zm-.3-.3.2.2h-.2zM15 7l-.3.1v.2l.1-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#edb92e",
    d: "m18.8 8.8-.4-.4q.3-1 0-2.3V6v1.6l-.2 1 .1.1.3.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "M18.3 8.4h.2v.1h.1v.1h.1v.2-.1h-.1v-.1h-.1v-.1zm.2-2.3v2.2h-.1v-.5h.1zm-.1-.2h.1V6zm0 .2h-.1v-.2.2m0 1.4V6.3h-.1v-.1 1.3m-.2 1v-.7h.1v-.3.8zm.2 0H18v-.1zm.1.3h-.1v-.1.1zm.3 0h-.1m0 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#edb92e",
    d: "m18 9.6.1-.1v-.2q0-.3.3 0l.3.2h.1v.5h-.1l-.3.3q-.3.2-.2 0V10H18z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "M18.4 9.2v.2zm.4.6v-.2zm0 .2v-.2zm-.4.3h.1V10h.1v.1h-.1zm-.3 0h.2v.1H18zm-.1-.8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "M18.8 9.8q-.3 0-.4.3 0-.3.4-.3m0 0-.4-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#edb92e",
    d: "m18.2 9.2.1.1v.3l-.1.2v.1l.1.3-.1.1V10H18v-.4l.2-.1v-.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "M18.3 9.8h-.1v-.2zm0 .5V10zm-.2 0h.2m-4.4-.2v-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#edb92e",
    d: "M16 9h.2q.3 0 .1.3l-.2.3v.1h-.4l-.3-.2q-.3-.3 0-.3h.1v-.4h.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "M16.2 9H16zm.1.3V9h-.1.1zm-.1.3v-.2h.1zm-.1.2v-.2zm-.4 0h.2zm0-.1v.1m-.3-.2v.1h.1-.2zm0-.4v.3-.2m.1-.1v.1zm0-.2h-.1m.4 1-.3-.4zm0 0q0-.3.2-.5-.2.1-.1.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#edb92e",
    d: "M16.3 9v.2h-.7q0 .2-.2.1l-.1-.1h.2v-.4h.3l.1.1.1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "M16.2 9.2V9zm-.3 0h.2zm-.5.1v-.1zh-.2m.1-.2h-.1m.7-.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#edb92e",
    d: "M15 9.9q-.1-.3.1-.1h.2l.1.1.1.1.1.2v.5l-.2.1-.1-.2v-.1h-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "M15.3 9.5H15v.1-.1zm.5.7V10h-.1zm-.2.3v-.2h.1zm-.1.2v-.2h.1v.1zm-.1-.3v-.1zm-.2-.1h.1m.4-.3h-.2l-.2-.2.2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#edb92e",
    d: "m15 9.5.2.1v.5l.2.1.1.3v.1h-.1v-.2l-.2-.1h-.1v-.7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "M15.2 9.6H15m0 .3v-.2zm-.1 0v.3-.1zm0-.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#edb92e",
    d: "m17 10-.1.2v.1q0 .3-.2.1l-.3-.2h-.1V10l-.1-.2.1-.1.2-.3q.2-.3.2 0v.2h.2l.1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "M16.9 10.2V10m-.2.2h.1v-.1h.1v.1zm-.3-.2h.1v.1h.1v.1h-.1zm-.2-.5v.2zm.3-.3h-.1v.1-.2m.3 0h-.1V9h-.2.2zm0 .2v-.1m.1 0h-.1m.1.5v.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "M16.2 10q.3 0 .4-.3 0 .3-.4.3m0 0q.3 0 .5.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#edb92e",
    d: "M16.9 10.4h-.2v-.7q-.2 0-.1-.3h.1v.2h.2l.1.1v.4h-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "M16.7 10.4h.1zm0-.4v.2zm-.1-.6v.2l.1.1h-.1zm.1 0h-.1zm.1.2v-.2zm.1.8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#edb92e",
    d: "M16 9.6q.2 0 .3.4 0 .3-.3.3l-.3-.3q0-.3.2-.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "M16.3 10h-.1v-.1H16v-.1h.2v.2zm-.3.4h.2V10h.1v.2h-.1v.1zm-.4-.4v.2h.2v.1h.1-.2l-.1-.1zm.3-.4v.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#edb92e",
    d: "m16 9.7.2.3q0 .2-.2.2l-.3-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "M16.2 10H16v-.1zm-.2.3V10h.1v.2zm-.1-.6v.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0c4076",
    d: "m16 9.8.1.2-.1.2-.2-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "M16.1 10H16zm-.1.2V10h.1v.1zm-.1-.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19 8.2q.4 0 .4.3t-.3.3l-.3-.3q0-.3.3-.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "m19.4 8.5-.3-.3h.3zm-.3.3.3-.2v-.1l-.1.2zm-.3-.3.3.2h-.3zM19 8l-.2.2v.2h-.1l.1-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19 7.6q.4 0 .4.3a.3.3 0 0 1-.4.3l-.2-.3q0-.2.3-.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "M19.4 8q0-.3-.2-.3h-.1v-.1l.3.2zm-.3.3.3-.2v-.2l-.1.3zm-.3-.4.3.3h-.3zm.3-.3-.2.2v.1h-.1l.1-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19 7.1q.4 0 .4.3a.3.3 0 0 1-.4.3l-.2-.3q0-.3.3-.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "m19.4 7.4-.2-.2h-.1V7l.3.1zm-.3.4.2-.3h.1l-.1.2zm-.3-.4.2.3-.2-.1zm.3-.3-.3.2v.1l.1-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19 5.7q.4 0 .4.3t-.3.3l-.3-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "m19.4 6-.2-.3h-.1.3zm-.3.3.3-.2V6l-.1.2zm-.3-.3.3.2h-.3zm.3-.4-.2.2V6h-.1l.1-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19 6.1q.4 0 .4.3t-.3.3-.3-.3.3-.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "m19.4 6.4-.2-.2h-.1V6l.3.1zm-.3.3q.2 0 .3-.2l-.1.2zm-.3-.3.3.3-.3-.1zm.3-.3-.2.2v.1h-.1l.1-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19 6.6q.4 0 .4.3t-.3.3-.3-.3.3-.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "M19.4 7q0-.3-.2-.3h-.1v-.1l.3.1zm-.3.2q.2 0 .3-.2l-.1.2zm-.3-.3.3.3-.3-.1zm.3-.3-.3.3.1-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#edb92e",
    d: "M19.3 8.7h.2q.3 0 .1.3l-.2.2-.1.2h-.4l-.1-.2-.2-.2q-.2-.3 0-.3h.2v-.1l.2-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "M19.5 8.8h-.1zm.1.3h.1zm-.2.2V9h.1v.1zm-.1.2h.1m-.2 0h.2zm-.2 0h.2zm-.1-.1h.1zm-.2-.3h.2v.1h-.1zm0-.3V9zm.4-.2H19m.2 0H19zm.1.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "m19 9.5-.2-.5.3.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#edb92e",
    d: "M19.6 8.8V9h-.3l-.2-.1h-.2q0 .2-.3 0h.2v-.2h.2v-.1h.2l.1.1v.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "M19.2 9h.2zm-.6 0h.3zm0-.2V9zm.6-.2H19zm.3.2h-.1zm.2 0h-.2zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#edb92e",
    d: "M19 9.4q.4 0 .4.4 0 .3-.3.3l-.3-.3q0-.3.3-.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "M19.1 9.5q0-.2.3-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#edb92e",
    d: "M24.4 9.5v-.7c.6-.8.6-.9.2-1.2L23 7l-.3-.3c1 0 2.3.5 2.9 1q.4.5-.6 1.8-.4.4-.5 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "M24.4 9v.4zm0-.2V9m.2-1.2V8h.1v.5l-.1.1v.1h-.1v.1l-.1.2.1-.2.1-.1v-.1h.1v-.2h.1V8h-.1v-.1zM23 7h.4l.1.1h.1l.1.1h.2l.1.1h.1l.1.1h.2v.1h.1l.1.1h.1-.1v-.1h-.2v-.1H24l-.1-.1h-.2v-.1h-.2l-.1-.1h-.2zh-.3zm-.3-.3.1.1h.1V7v-.2zm2.9 1h-.1v-.1h-.2v-.1H25v-.1h-.2l-.1-.1h-.1l-.1-.1-.2-.1h-.2V7H24l-.2-.1h-.2l-.2-.1H23l-.1-.1h-.3.6l.1.1h.3l.1.1h.2l.1.1h.2l.1.1h.2v.1h.2v.1h.2v.1h.2v.1h.1v.1h.1zM25 9.4l.1-.1V9h.1v-.2l.1-.1.1-.1v-.2h.1v-.2l.1-.1v-.4h-.1v.7h-.1v.2h-.1v.2h-.1V9l-.1.1zm-.5.1h.4v-.1h.1-.2v.1zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#edb92e",
    d: "M24.6 9.5V9l.4-.6V8q0-.2-.3-.4t-.6-.4L23 6.8l.1.2 1.5.6c.4.3.4.4-.2 1.2v.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "M24.6 9.3v.2zm0-.3v.3zm.4-.6v.2h-.1v.1h-.1V9h-.1.1v-.1h.1v-.1l.1-.1zm0-.5v.4-.1h.1v-.3m-.3-.4v.1h.1v.1h.1v.1-.2h-.1v-.1zm-.6-.4h.2v.1h.1l.1.1h.1-.1l-.1-.1h-.1zM23 6.8h.4V7h.6v.1h.2-.1L24 7h-.2l-.1-.1h-.4v-.1zm.2.2-.1-.2zm1.5.7h-.1v-.1h-.2l-.1-.1H24l-.1-.1h-.1l-.1-.1h-.3V7h-.2l-.1-.1h.1V7h.2l.1.1h.2l.1.1h.1l.1.1h.1l.1.1h.1l.1.1zm-.2 1.1.1-.1.1-.1v-.1h.1v-.2h.1v-.4h-.1v-.1h-.1v.1h.1v.5l-.1.1v.2h-.1zm0 .7V9zm.2 0h-.2zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#edb92e",
    d: "M19.7 5.9q0-.2 0 0v.4q2.3 0 2.6.6.2.6-.6 1.6v.1q.2.2.1.4a1 1 0 0 0 1 .1L23 9l.1-.1.4-1.4C24 6.1 20.2 6 19.6 6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "M19.8 6v-.2h-.1zm0 .1h.1v-.2.2m0 .2h.1m2.6.6v-.1H22l-.1-.1h-.2l-.1-.1h-.3l-.1-.1h-1.4 1.5l.1.1h.3l.1.1h.1l.1.1h.1v.1h.1zM22 8.3l.1-.1.1-.1.1-.2.1-.1v-.1l.1-.1v-.1l.1-.1v-.2l.1-.1v-.4.5l-.1.1v.2h-.1v.1l-.1.2-.1.1-.1.1v.1zm0 .2v-.2zm.1.4v-.4zm1 0H22h.2V9h.7m.1.1h-.1v.1V9zm.6-1.5h-.1v.3h-.1V8l-.1.1v.2l-.1.1v.2h-.1v.2-.2l.1-.1v-.3h.1v-.3h.1v-.3h.1zm-4-1.5H21l.2.1h.6l.1.1h.2l.2.1h.2l.1.1h.2l.1.1.2.1.2.2.1.1.1.1v.5V7h-.1v-.2h-.2l-.1-.1-.2-.1h.1l-.2-.1h-.1l-.2-.1h-.2l-.1-.1h-.4l-.2-.1h-.7l-.2-.1h-.9m0 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M22.5 8.5q-.2 0-.3.3l.3.2q.3 0 .3-.2t-.3-.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "m22.2 8.8.3-.3-.2.1zm.3.3-.2-.2v-.1.2zm.3-.3-.2.2zm-.3-.3.3.1v.2l-.1-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M25 9q-.3 0-.3.3t.2.3a.3.3 0 0 0 0-.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "m24.6 9.3.2-.2h.1-.2zm.3.3-.2-.1v-.2.3zm.3-.3q0 .2-.2.3l.2-.1zm-.3-.2.3.1v.1l-.1-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M25.2 8.6q-.3 0-.3.3t.3.2l.2-.2q0-.3-.2-.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "m24.9 8.9.2-.3zm.3.2L25 9v-.1h-.1l.1.2zm.3-.2-.2.2h-.1.2zm-.3-.3.2.1V9v-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M25.4 8.1a.3.3 0 0 0 0 .5.3.3 0 0 0 0-.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "m25.1 8.4.2-.3h.1zm.3.3-.2-.2v-.1.2zm.3-.3-.2.2h.2zm-.3-.3q.2 0 .2.2h.1l-.1-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#edb92e",
    d: "M20.8 9q-.2.2-.1.3 0 .2.1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "M20.7 9.3V9zm.1 0h-.1m0-.3v.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M20.8 9.2c-.4 0-.3.6-.2.7q0 .3.3 0s.2-.7-.1-.7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "M20.6 10v-.8h.1-.1v.2h-.1v.5m.3 0h-.3.2m-.1-.8v.7-.2h.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#edb92e",
    d: "m23.6 9.4-.1.3h.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "M23.5 9.7v-.2h.1v-.1.1h-.1zm.1 0h-.1m0-.3v.3l.1-.1v-.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M23.6 9.5c-.3 0-.4.6-.4.7q0 .3.3.1c.1 0 .4-.6.1-.8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "M23.2 10.2v-.3l.1-.1v-.1l.1-.1h.2v-.1h-.2v.1h-.1v.3h-.1zm.3.1h-.1v.1zm.1-.8h.1v.5h-.1v.2-.2h.1l.1-.1v-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#edb92e",
    d: "M19.9 6.1a5 5 0 0 1 2.3.4q1 .4-.2 2l.1.5H22v-.4q-.2 0 0-.1.7-1.1.5-1.6-.3-.7-2.5-.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "m22.2 6.5-.1-.1h-.2l-.1-.1h-.3v-.1h-1.6 1.7v.1h.3v.1h.2zm-.2 2h.1v-.1l.1-.1v-.1l.2-.1v-.2l.1-.2.1-.1v-.9l-.1-.1-.1-.1h-.1l.1.1h.1v.2h.1v.8l-.1.1v.1h-.1V8l-.1.2h-.1v.1zm.1.5v-.4H22V9zM22 9h.2zm0-.4V9zm.6-1.7v.5h-.1v.2l-.1.1V8H22v.1l-.1.1v.1l-.1.1v.1-.2h.1l.1-.1V8l.1-.1v-.1h.1v-.2l.1-.1v-.2h.1v-.5m-2.6-.6h1.4l.1.1h.4v.1h.2v.1h.1l.1.1h.1v.1h.1V7v-.1l-.1-.1-.1-.1H22l-.1-.1h-.2v-.1h-.5l-.1-.1h-1.3m0-.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M23.6 6.4q-.2 0-.3.2t.3.3a.3.3 0 0 0 .2-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "m23.3 6.6.2-.2h.1-.2zm.3.3-.2-.2v.2zm.3-.3-.2.3.2-.1zm-.3-.3.2.2v.1h.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m23 6.2-.2.3a.3.3 0 0 0 .5.1v-.1q0-.3-.2-.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "M22.8 6.5q0-.2.2-.3h-.2zm.3.3-.2-.2v-.1h-.1l.1.2zm.3-.3-.2.2H23h.2zm-.3-.3.2.1v.2-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#edb92e",
    d: "M23 6.4q.5.4.5.8L23 8.7l-.5.4q0 .2.2.1l.3-.3.1-.1.4-1.4q.2-.7-.6-1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "M23.5 7.3v-.4h-.1v-.1h-.1v-.1h-.1l-.1-.1H23h.1v.1h.1l.1.1h.1zM23 8.7h.1v-.3l.1-.1V8l.1-.1v-.2h.1v-.4h.1v-.1.2h-.1v.3l-.1.1v.3h-.1v.2l-.1.1zm-.4.4.1-.1.1-.1h.1v-.1h.1v-.1h-.1v.1h-.1V9h-.1zm.2.1h-.2zm.3-.3H23V9h-.1v.1h-.1v.1h.1V9zm.1 0v-.1H23m.5-1.5h-.1v.3h-.1V8l-.1.1v.2l-.1.1v.2l-.1.1v.1-.2l.1-.1v-.2l.1-.1V8l.1-.1v-.2l.1-.1zm-.7-1 .1.1h.1l.1.1h.1v.1h.1V7h.1v.4-.5h-.1v-.1h-.1v-.1h-.1l-.1-.1m0 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#edb92e",
    d: "M24.7 9.7h.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "M25.1 9.8h-.3zm-.4-.1h.3v.1-.1zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#edb92e",
    d: "M24.7 9.5h-.2q-.2-.1-.2.2v.5h.2l.3-.4c0-.2.3-.2 0-.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "M24.6 9.5h.1zm-.3.2v-.2h.1-.1zm0 .3v-.3.2m0 .2h.1zm.2 0h-.1m.3-.4h-.1v.2h-.1v.1h-.1v.1h.1V10l.1-.1v-.2m0-.4v.4-.1h.1v-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#edb92e",
    d: "M24.7 9.5h-.3q0 .3.3.2h.4c.2-.3-.3-.3-.4-.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "M24.4 9.5h.2zm.3.2h-.2v-.2h-.1v.2zm.3 0h-.2.3m-.4-.2h.5v.2-.2h-.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m20.1 5.5-.2.3q0 .3.2.3t.3-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "m19.8 5.8.2-.2h.1-.2zm.3.3-.2-.2zm.3-.3q0 .2-.2.2v.1l.2-.1zm-.3-.3.3.2v.1l-.1-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m20.7 5.5-.3.3q0 .3.3.3t.3-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "m20.4 5.8.2-.2h-.2zm.3.3q-.2 0-.2-.2h-.1l.1.2zm.3-.3-.2.2h-.1v.1l.2-.1zm-.3-.3.2.2v.1-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m21.2 5.6-.2.3q0 .2.2.2t.3-.2-.3-.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "m21 5.9.1-.3h.1l-.2.1zm.2.3L21 6v-.1.2zm.3-.3-.1.2h-.2.3zm-.3-.3.3.1V6l-.1-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M21.8 5.7a.3.3 0 0 0 0 .5q.2 0 .2-.2t-.2-.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "m21.5 6 .1-.3h.2l-.3.1zm.3.3-.3-.2V6zM22 6l-.2.2h-.1.2zm-.3-.3.2.1V6v-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m25.1 7.1-.2.3q0 .2.2.3t.3-.3l-.2-.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "m24.8 7.4.2-.2h.1V7l-.2.1zm.3.3-.2-.2v-.1.2zm.3-.3-.2.2h.2zm-.3-.3.3.2-.1-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M24.7 6.8q-.3 0-.3.3t.3.3l.2-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "m24.4 7 .1-.1h.2v-.1zm.3.4-.3-.3.1.2zM25 7l-.2.2h-.1.2zm-.3-.3.2.2v-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m24.1 6.5-.2.3q0 .3.2.3t.3-.3l-.2-.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "m23.8 6.8.2-.2h.1-.2zm.3.3L24 7v-.2.3zm.3-.3-.3.3.3-.1zm-.3-.3.3.2v.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m25.5 7.6-.3.2q0 .3.3.3t.3-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "m25.2 7.8.2-.2h-.2zm.3.3-.2-.1v-.2h-.1zm.3-.3-.2.3h-.1l.2-.1zm-.3-.3.2.2v.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#edb92e",
    d: "m20.3 12.3 1 .6 1-.5-1-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "m21.4 11.9 1 .6zm-1 .4 1-.4zm0 0h-.1m1 .6-1-.6.9.6m.9-.5-1 .5zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c6363c",
    d: "M21.4 12q-.5 0-.5.3t.4.4.5-.3-.4-.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "M20.9 12.4v-.2h.3V12h.1-.3v.1h-.1v.1m.4.3h-.1l-.1-.1H21v-.2h-.1v.1h.1v.1h.2zm.5-.3h-.1l-.1.1h-.3.4zm-.4-.4h.2v.1h.1v.2h.1V12h-.1l-.1-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#edb92e",
    d: "m23.5 12-1 .4.8.6c.3 0 .4-.8.2-1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "m22.5 12.5 1-.4zm.9.5-1-.6zm.1-1h.1v.7h-.1v.1h-.1v.1h.1v-.2h.1V12m0 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0c4076",
    d: "M23.5 12.2q-.4 0-.5.3t.4.3q.3 0 .3-.2t-.2-.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "M23 12.5h.1l.1-.1h.3-.4v.1zm.4.4h-.2v-.1H23v-.2.2h.1v.1zm.4-.3h-.1v.1h-.1v.1h-.1.2zm-.3-.4v.2h.1v.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m20.2 12.5-.2.1.2.2.1-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "M20.2 12.8H20v-.1zm.2-.2h-.1v.1zm-.2-.1h.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M22.4 12.6q-.2 0-.2.2l.2.1.1-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "M22.2 12.8h.1v-.1.1zm.2.1h-.1v-.1h-.1v.1h.1m.1-.1h-.1v.1zm-.1-.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m22.4 12-.1.1.1.1a.1.1 0 0 0 .2 0q0-.2-.2-.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "M22.3 12.1h.1zm.1.2V12h-.1zm.2-.2h-.1m-.2-.2.1.1v.1h.1V12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m20.2 11.9-.1.1.1.2a.1.1 0 0 0 .1-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "M20 12h.1zm.2.2V12H20zm.2-.2h-.1zm-.2-.1h.1v.1-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#edb92e",
    d: "m24 10.6-.3.2q0-.3.3-.7l.1-.4.2.1v.3q-.3.3-.3.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "M23.7 10.8h.2v-.1zm.3-.7v.1h-.1v.3h-.1v.3-.3h.1v-.2l.1-.1zm.2-.4v.1H24v.2h.1v-.2m0 .4v-.3zm0 .1h.1m-.1.4v-.3h.1v-.1H24v.4m0 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#edb92e",
    d: "M24.1 9.7v.3l-.1.1-.1.2v.2l-.2.3v-.6l.2-.2.2-.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "M24 10.1h.1zm-.1.2v-.1m-.1.2v-.1l.1-.1zm0 .3v-.4zm.1-.8h-.2v.2-.1zm.2-.2h-.2v.1h.1zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#edb92e",
    d: "M24.5 10.1h-.2c-.3 0-.4.5-.1.6l.1-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "M24.4 10h.1m-.1 0h.1v.1m-.1.7v-.5h.1V10H24v.6zm.1-.1h-.1v.1m.2-.3h-.1v.2zm0-.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#edb92e",
    d: "M24.4 10.2c-.2-.1-.4.3-.2.4l.2-.2q.2-.1 0-.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "M24.2 10.6v-.4h.2-.2v.1H24v.3zm.2-.2h-.1l-.1.1h.1zm0-.3v.3-.1h.1v-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0c4076",
    d: "M24.4 10.2q-.3 0-.2.3h.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "M24.2 10.5v-.2h.1-.1zm.3 0h-.1zm-.1-.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M22.7 8q-.2 0-.2.3t.2.3.3-.3-.3-.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "m22.4 8.3.2-.2h.1V8l-.2.1zm.3.3-.2-.3v.3zm.3-.3-.1.2h-.2v.1l.3-.1zm-.3-.3.3.2V8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M23 7.5q-.3 0-.3.3t.3.3.2-.3-.3-.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "m22.6 7.8.2-.2h.1-.2zm.4.3q-.2 0-.3-.2V8zm.3-.3-.2.3H23zm-.3-.3.2.2v.1-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M22.3 5.9q-.3 0-.3.2t.3.3a.3.3 0 0 0 .2-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "m22 6.1.2-.2H22zm.3.3-.3-.2.1.2zm.3-.3-.2.3h-.1l.2-.1zm-.3-.3.2.2v.1V6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M22.7 6a.3.3 0 0 0 0 .6q.3 0 .3-.2t-.3-.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "m22.4 6.4.2-.3h.1-.2zm.3.3-.2-.2v-.1.2zm.3-.3-.2.2h.2zm-.3-.4.3.2v.1l-.1-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m23 6.5-.2.3a.3.3 0 1 0 .5 0q0-.3-.2-.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "m22.8 6.8.2-.3h-.2zm.3.3-.3-.2v-.1l.1.2zm.3-.3-.2.2H23h.2zm-.3-.4a.3.3 0 0 1 .2.4.3.3 0 0 0-.2-.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M23.1 7q-.2 0-.3.3l.3.3q.3 0 .3-.3t-.3-.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "M22.8 7.3 23 7h.1-.1zm.3.3-.2-.3v.2zm.3-.3-.2.2h.2zm-.3-.3.3.1v.2l-.1-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#edb92e",
    d: "m19.4 8.8.4-.4q-.3-1-.1-2.3l.1-.2v1.6l.2 1-.2.1-.2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "M19.8 8.4h-.1v.1h-.1v.1h-.1v.2-.1h.1v-.1l.1-.1zm0-2.3h-.1v2.2h.1v-.4l-.1-.1V6.1m0-.2h-.1V6zm0 .2h.1v-.2h-.1zm0 1.4V6.2h.1V7h-.1zm.2 1v-.6l-.1-.1v-.3.9zm-.2 0h.2v-.1zm-.2.3h.1v-.1h.1v-.1.1h-.1m-.2 0h.1m0 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#edb92e",
    d: "m20.2 9.6-.2-.1v-.2q0-.3-.2 0l-.3.2h-.1v.5h.1l.3.3q.3.2.2 0V10l.2-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "M19.8 9.2h.2v.2-.2zm-.3.3h.1v-.1zm-.1 0h.1zm0 .3v-.2zm0 .2v-.2zm.1.1h-.1m.3.2h-.1v-.1h-.1V10v.1h.1zm.3 0h-.3v.1h.2zm.2-.4h-.1v.1m-.7-.1q.3 0 .4.3 0-.3-.4-.3m0 0 .4-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#edb92e",
    d: "m20 9.2-.1.1v.9l.1.1V10l.1-.1.1-.1v-.3l-.2-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "M19.9 9.8h.1v-.2zm0 .5V10zm.1 0h-.1m.2-.2H20m-.1-.7h.1zm0-.1h.1m4.4.8v-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#edb92e",
    d: "M22.3 9H22q-.3 0-.1.3l.1.3v.1h.6l.2-.2q.3-.3 0-.3h-.1V9l-.1-.2h-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "M21.9 9.4V9h.1-.1zm.1.3v-.2h-.1zm0 .2h.1v-.2zm.3 0H22zm.5-.3h-.1v.1h-.1zm0-.4h.1v.3-.2m-.1-.1v.1zm0-.2h-.1zm-.3 0h.1zm-.2.9.3-.4zm0 0v-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#edb92e",
    d: "M22 9v.2h.6q0 .2.2.1l.1-.1h-.2V9l-.1-.2h-.2l-.1.1-.1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "M22 9.2V9zm.3 0H22h.2m.1 0h-.1zm.4.1h-.2v-.1.1zm.1-.2h-.1v.1zm-.2 0h.1zm0-.3h-.1zm-.2 0h.1m-.1 0h.1zM22 9h.2zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#edb92e",
    d: "M23.1 9.9q.1-.3-.2-.1l-.2.1-.1.1-.1.2-.1.2.2.3.1.1.1-.2v-.1h.2V10z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "M23 9.8h.1m.1-.1v.1zm-.2-.2h.2v.1-.1zm-.4.3h.2zm-.1.4V10h.1zm0 .1h.1zm.2.2v-.2h-.1zm.1.2v-.2h-.1zm.4-.8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "m22.5 10 .1.1.1.1v-.1zm0 0h.2l.2-.2-.2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#edb92e",
    d: "m23.1 9.5-.1.1v.5l-.2.1-.1.3v.1h.1v-.2l.2-.1q.2-.3.1-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "M23 9.6h.1m0 .3v-.2zm-.3.6h.1v-.1zm.4-.6v.3zm0-.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#edb92e",
    d: "m21.2 10 .1.2v.1q0 .3.2.1l.3-.2h.1v-.5l-.2-.3q-.2-.3-.3 0v.2h-.1l-.1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "M21.3 10.2V10m.2.2h-.1l-.1-.1v.1zm.3-.2h-.1v.1h-.1v.1h.1zm.2-.5v.2zm-.1 0h.1m-.2-.3h.1v.1-.2m-.3 0h.3-.2zm0 .2v-.1m-.2.5v.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "m22 10-.4-.3q0 .3.4.3m0 0q-.3 0-.5.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#edb92e",
    d: "M21.3 10.4h.1q.2-.1 0-.4v-.3q.3 0 .2-.3h-.1v.2h-.2l-.1.1v.4h.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "M21.5 10.4h-.1zm0-.4v.2zm0-.1h-.1v.1zm0-.2v.1zm.1-.3v.2l-.1.1h.1zm-.1 0h.1m-.1.2v-.2zm-.2.7h.1v-.1m.1.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#edb92e",
    d: "M22.3 9.6q-.3 0-.4.4 0 .3.3.3t.3-.3-.2-.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "M21.9 10h.1v-.1h.1v-.1h.1-.2v.1zm.3.4H22V10h-.1v.2h.1v.1zm.4-.4h-.1v.2h-.2v.1h-.1.2v-.1h.1zm-.3-.4v.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#edb92e",
    d: "M22.3 9.7q-.3 0-.3.3t.2.2.3-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "M22 10h.1v-.1h.1zm.2.3V10H22v.2zm.3-.3h-.1v.1h-.1zm-.2-.3h.1v.2-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0c4076",
    d: "m22.2 9.8-.1.2.1.2.2-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "M22 10h.1zm.2.2V10H22v.1zm.2-.2h-.1zm-.1-.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#edb92e",
    stroke: "#21231e",
    strokeWidth: 0.1,
    d: "m23.3 13 .1.2v.2h-.2a49 49 0 0 1-8.5-.2l.2-.1q4.1-.5 8.3 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "M16 13.3h.8v-.1h.2-.6.3v.1h.3zm2-.1h-1 1.1m1 0h-.9zm1.1 0h-1zm1 0h-1 1.1m1.1 0v.1h-1 .5-.5v-.1zM19 11.7h.2zm-1.1 0h.2zm-.8.1h.2zm-.4 0h.4zm-.8 0h.7zm-1.2.2h.2l.1-.1h.8-1.1m0-.3v.2h-.1zm1.1-.1h-.9l-.1.1h-.1.6v-.1zm1.7-.1H16v.1h.9v-.1zm.8 0h-.7zm.4 0h-.1zm.3 0h-.2zm.2 0H19zm.2 0H19zm.2 0h-.2zm.2 0h-.1zm1 0H20h.6m1.8 0h-1.7v-.1zm1.1.2h-1.2v-.1h1.2m0 .3v-.3h.1v.2zm-1.2-.1h1.2-1.1m-.8 0h.8-.7m-.4-.1h.3zm-.3 0h.2zm-.7 0h.1zm-.6 0h.1m-.5-.1h.2zm0 .1-1 .5zm1 .5-1-.5zm-1 .5 1-.5zm-1-.5 1 .5zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0c4076",
    d: "M19 12q.5 0 .6.3-.1.3-.5.3t-.5-.3.5-.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "M19.6 12.3h-.1V12h-.2.2v.1h.1zm-.5.3h.3v-.1h.1v-.1.1h-.1v.1H19m-.5-.3h.1v.1h.3v.1h-.2v-.1h-.1zm.5-.3h-.2l-.1.1h-.1v.2-.2h.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#edb92e",
    d: "M19 9.4q.4 0 .4.4 0 .3-.3.3l-.3-.3q0-.3.3-.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "M19.5 9.8h-.1v-.1h-.1v-.1H19h.3v.2m-.4.4V10h.2v-.2l.1-.1v.2h-.1v.1zm-.4-.4v.2h.2v.1h.1-.2l-.1-.1zm.4-.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#edb92e",
    d: "M19 9.5q.3 0 .3.3t-.2.2-.3-.2.3-.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "M19.4 9.8h-.1v-.1H19h.2zm-.6 0h-.1zm.3-.3H19v.1-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0c4076",
    d: "M19 9.6q.3 0 .3.2l-.2.1-.2-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "M19.3 9.8H19h.1m-.2.2h.1v-.1.1zm0-.4h.1v.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c6363c",
    d: "M11.6 13.4v12a8 8 0 0 0 4.6 7.3 7 7 0 0 0 5.8 0q1.3-.6 2.4-1.7a8 8 0 0 0 2.1-5.5V13.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M11.6 13.3v13.3l.1.2v.4l.1.2v.2l.1.2v.2l.1.2.1.1v.2l.2.2v.2l.1.1.1.2.1.2v.1l.2.2v.2l.2.1v.2l.2.1.1.2.1.1.2.2.2.2v-.2l-.2-.1v-.2l-.2-.1-.1-.2-.1-.1-.1-.1-.1-.2-.1-.2-.1-.1-.1-.2-.1-.1V29l-.2-.2v-.2l-.1-.1v-.2l-.1-.2-.1-.2v-.1l-.1-.2v-.2l-.1-.2v-.4l-.1-.2V13.4h14.7v13.2l-.1.2v.2l-.1.2v.4l-.1.2-.1.1v.2l-.1.2v.2l-.2.1v.2l-.1.2-.1.2v.1l-.2.2v.1l-.2.2v.2l-.2.1v.1l-.2.2-.1.1-.1.2-.2.1v.1l-.2.2-.1.1-.2.1-.1.1-.2.2-.2.2-.2.1-.1.1-.2.1-.1.1h-.2l-.1.2h-.2l-.2.1-.1.1h-.2l-.2.2h-.3l-.2.1H21l-.1.1h-.2l-.2.1h-.6l-.1.1H19v.1h1.3l.2-.1h.2l.2-.1h.1l.2-.1h.2l.2-.1.1-.1h.2l.2-.2h.1l.2-.1.2-.1.1-.1.2-.1.1-.1.2-.1.1-.1.2-.1.1-.1.2-.2h.1l.1-.2.2-.1.1-.2.1-.1.1-.1.2-.2v-.1l.2-.2.1-.1.1-.2.1-.1.1-.2.1-.1.1-.2v-.2l.2-.1v-.2l.1-.2.1-.2v-.1l.1-.2.1-.2v-.2l.1-.2v-.2l.1-.2V27l.1-.2V13.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#21231e",
    strokeWidth: 0.1,
    d: "m19.2 32.7.2-.1v-.7l-.3-5.6h-.2l-.2 5.6v.7zm.7-.1h-.3l-.1-.7-.1-5.7q.5 4 .9 5.7v.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#21231e",
    strokeWidth: 0.1,
    d: "M20.7 32.5h-.3l-.1-.6-1-5.7h.3q.8 3.9 1.4 5.5.2.3 0 .7h-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#21231e",
    strokeWidth: 0.1,
    d: "M21.5 32.3h-.2q-.2-.1-.3-.6c-.5-1.1-.7-3-1.4-5.5l.2-.1h.2c.8 2.5 1 4.3 1.8 5.4l.1.6-.2.1zm-3.2.3h.3l.1-.7.1-5.7q-.5 4-.9 5.7v.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#21231e",
    strokeWidth: 0.1,
    d: "M17.5 32.5h.3l.1-.6q.4-1.7.9-5.7h-.2l-1.4 5.5v.7h.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#21231e",
    strokeWidth: 0.1,
    d: "M16.7 32.3h.2q.2-.1.3-.6.6-1.7 1.4-5.5l-.2-.1h-.2c-.8 2.5-1 4.3-1.8 5.4l-.1.6.2.1h.2Zm4.4-2h-.3l-.2-.6q-.7-1.6-1.8-5.5h.4q1 3.8 2 5.4.3.3.2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#21231e",
    strokeWidth: 0.1,
    d: "M20.4 30.5h-.2l-.2-.7-1-5.6h.2c.7 2.6.8 4.5 1.4 5.5q.3.4.1.7h-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#21231e",
    strokeWidth: 0.1,
    d: "M19.7 30.6h-.2l-.1-.7-.3-5.7h.2q.4 4 .8 5.6v.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#21231e",
    strokeWidth: 0.1,
    d: "M17.1 30.3h.2q.2-.1.3-.6.7-1.5 1.8-5.5H19q-1 3.8-2 5.4-.3.3-.2.6l.2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#21231e",
    strokeWidth: 0.1,
    d: "M17.8 30.5h.2l.2-.7 1-5.6H19c-.7 2.6-.8 4.5-1.5 5.5v.7h.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#21231e",
    strokeWidth: 0.1,
    d: "M18.5 30.6h.2l.1-.7.3-5.7H19q-.4 4-.8 5.6v.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#21231e",
    strokeWidth: 0.1,
    d: "M19.2 30.6h.2v-.7l-.1-5.7h-.4l-.1 5.7v.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#21231e",
    strokeWidth: 0.1,
    d: "M20.6 28.8h-.2l-.2-.6-1.4-5.5h.2l.1-.1q.9 3.9 1.6 5.4l.2.7h-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#21231e",
    strokeWidth: 0.1,
    d: "M20.1 29H20l-.1-.7-1-5.6h.2l.2-.1q.6 4 1 5.6l.2.6-.2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#21231e",
    strokeWidth: 0.1,
    d: "M19.6 29h-.2l-.1-.7-.2-5.7h.1l.6 5.7v.6l-.1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#21231e",
    strokeWidth: 0.1,
    d: "M17.6 28.8h.1l.3-.6q.5-1.6 1.3-5.5h-.1l-.2-.1q-.7 3.9-1.5 5.4l-.2.7h.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#21231e",
    strokeWidth: 0.1,
    d: "M18 29h.3l.1-.7 1-5.6h-.2l-.2-.1q-.6 4-1 5.6l-.2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#21231e",
    strokeWidth: 0.1,
    d: "M18.6 29h.2v-.7l.3-5.7H19l-.6 5.7v.6l.1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#21231e",
    strokeWidth: 0.1,
    d: "M19.1 29h.2v-6.4h-.4V29z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#21231e",
    strokeWidth: 0.1,
    d: "M18.8 24.8v.7h-.5c0 .3.5 2.5.8 2.5s.8-2.2.8-2.4l-.5-.1v-.7l-.3.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#edb92e",
    stroke: "#21231e",
    strokeWidth: 0.1,
    d: "M16 26q-.2-.1-.8.5l-.8 1.3-.3.2h-.7q-.4-.2-.4 0-.1.4.2.3h.7l-.7.2q-.4.1-.1.5.3.2.4 0c0-.2.6-.4.7-.6l-.5.8q-.2.1 0 .5h.3q.4 0 .3-.3l.2-.8v-.2q.4-.4.8-.3.3.1.4-.2l-.2-.4-.3.2-.3.2q-.2 0 .6-.7.6-1 .5-1.2Zm0 5.2q-.6.2-.3-1.3c.2-.6 1.4-.3.7.5q0-.3-.3-.3c-.4.1-.5 1 0 .8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#edb92e",
    stroke: "#21231e",
    strokeWidth: 0.1,
    d: "M13 28.2h-.4q.2-.4.5-.3l.1.2zm2.6-.2q.3-.3.4-.1-.2-.6-.5-.2l-.1.1zM14 29.5l-.1-.3-.2.2q-.3.4 0 .7h.1zm-.8-.6-.2.3q-.3-.7.3-.5v.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "M14.7 27.6v.1h.1v.1zm.1-.2v.2h.1-.1zm.3 0v.1h-.3v-.1zm-.1-.2v.2zm.4 0v.1h-.2v-.1H15h.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "M15.2 27v.2h.1v.1-.1h-.1zm.4 0v.1h-.1zh-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "M15.4 26.8v.2h.1v.1-.1h-.1zm.3 0h-.2v-.1h.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#21231e",
    strokeWidth: 0.1,
    d: "m18.2 25.8-.4-.2q-.4.3 0 1t.6 1.2q.5-.6.2-1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#21231e",
    strokeWidth: 0.1,
    d: "m18.6 25.5-.4-.3c-.2.2-.6.6-.3 1q.7.7.9 1.2.4-.5.2-1l-.4-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#21231e",
    strokeWidth: 0.1,
    d: "m17.6 25.3-.4-.2q-.4.2 0 1 .4.5.6 1.2.5-.6.2-1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15.7 20.8v3.4l-.4.7q-.3-.3-.3-.8V21q.4-1.1.7-.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "M15.6 24.2v-3.4h.1zm-.4.7v-.1h.1v-.1l.1-.1v-.4h.1v.4h-.1v.1l-.1.1zm-.2-.8v.4h.1v.2l.1.1v.1-.2H15V24m0-3.2V24zm.7 0v-.2h-.1v-.2h-.1v-.1h-.2v.1l-.1.1v.1l-.1.1v.2H15v-.2l.1-.1v-.1l.1-.1v-.1h.4v.3h.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M14 20.2v3.6a8 8 0 0 0 .5 2.5c.6-.2.7-1.5.6-2.7v-3.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "m13.9 23.8.1-3.6zm.6 2.5v-.1h-.1v-.3l-.1-.1v-.2h-.1v-.4H14v-.4l-.1-.2v-.4l-.1-.1v-.3.5l.1.1v.5l.1.1v.3l.1.1v.3l.1.1v.2h.1v.2zm.5-2.7v2.2h-.1v.2h-.1v.1h-.1v.1h-.1v.1h-.1l.1-.1h.1V26l.1-.2.1-.2v-.3h.1v-1.8m.2-2.6v.4l-.1.1v2.1V21m0-.8v.8-.7zm-1.2 0H15zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M13.4 20.8v3.5c0 .3.5 2.2.8 2.5.5-.4.4-2.2.3-2.7v-3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "M13.4 24.3v-3.5zm.8 2.5H14v-.4l-.1-.1V26l-.1-.1v-.2l-.1-.1v-.3l-.1-.1V25l-.1-.2v-.4.7h.1v.4h.1v.2l.1.2v.2l.1.2v.1l.1.1v.1zm.3-2.7v.3l.1.1v1.6l-.1.1v.2h-.1v.2h-.1v.1h-.1v-.1h.1v-.1l.1-.1v-.3h.1V24m0-2.5V24v-.6l-.1-.2zm0-1v1-.6h-.1zm-1.1.2h.5v-.1h.5-.8zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.9 21.6h1c-.2.4-.1 1.6 0 2.5.2.9.4 3-.5 3.6-.5-1.2-.1-2.3-.4-3.3q-.3-1.5-.1-2.8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "M13.8 21.6h-1zm.2 2.5-.1-.2v-.7h-.1v-1.6 1.8l.1.2zm-.6 3.6.2-.1v-.2h.1v-.1l.1-.1V27h.1v-.3l.1-.1V24v1.1l.1.1v1.4l-.1.1v.3h-.1v.2h-.1v.2h-.1l-.1.1zm-.4-3.3v.2l.1.2v2l.1.1v.3l.1.2v.2l.1.1v-.1l-.1-.1v-.2l-.1-.1v-.6H13zm-.1-2.8v2.5h.1v.3-.4h-.1v-1l-.1-.1zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m16.4 20.2-.2 3.3q0 .6-.3.7-.3-.3-.3-.8l.2-3.1q.5-1.2.6-.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "M16.3 23.5v-3l.1-.1v-.2 2.7l-.1.1zm-.4.8v-.1l.1-.1V24h.1v-.2l.1-.1v-.1.4H16v.1zm-.3-1v.5h.1v.2l.1.1v.1-.2h-.1v-.5h-.1zm.1-3v3-3.1m.7-.1v-.3h-.1v-.1H16v.2h-.1v.1l-.1.1v.1-.3h.1v-.1l.1-.1.1-.1h.2v.2l.1.1zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M14.8 18.1v2.8l.2 1q.3-.2.4-.8v-2.4l-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "M14.8 20.9V18zm.2 1v-.1l-.1-.1v-.2h-.1v-.6.6l.1.1v.1zm.4-.8v.5h-.1v.1h-.1v.1H15v.1-.1h.1v-.2h.1v-.3h.1zm0-2.4V21zm-.5-.5.1.1h.1v.1h.1v.1h.1-.2v-.1H15v-.1zm-.1-.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m15.4 18.6.3 3.3q.3-.2.4-.7v-2q-.3-.1-.7-.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "M15.5 21v-2.4zm.2.9-.1-.1v-.2h-.1V21v.5h.1v.2zm.4-.7v.3H16v.2h-.1v.1h-.1v.1h-.1l.1-.1v-.1h.1v-.1l.1-.1v-.3m0-2v1.9zm-.6-.6H15v-.2zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m14.9 18-.7-.9c0 .5-.2 3.7 0 4q0 .5.2.8.4-.2.4-.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "m14.3 17.1.6 1zm-.1 4v-3.8h.1v-.1 1.9l-.1.2V21m.2.8-.1-.1v-.1l-.1-.1V21v.5h.1v.2zm.4-.7v.4h-.1v.1h-.1v.1h-.1v.1-.1h.1v-.1l.1-.1zm0-3.2V21v-3m0 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M13.6 20v1q0 .6.2 1 .3-.2.4-.8-.1-2 .2-4l-.6-.3a10 10 0 0 0-.2 3.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "M13.6 21v-.9 1m.2 1V22h-.1v-.2l-.1-.1V21v.6h.1v.1zm.3-.8v.5H14v.1h-.1v.1h-.1l.1-.1.1-.1v-.2h.1zm.3-4v.8l-.1.2v1h-.1v2V18l.1-.2v-.6m-.5-.3v.1h.2l.1.1h.1v.1h-.1V17H14zm-.3 3.1v-.3h-.1v-1.1l.1-.2v-.6l.1-.2v-.4l.1-.2v1l-.1.2v.6l-.1.1zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m13 21 .1.6q0 .5.4.9.3-.3.3-.7c-.3-2.1-.2-3.5.2-5.2q-1.6 1-1 4.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "M13 21.6V21zm.5.9-.1-.1v-.1h-.1V22h-.1v-.3H13v-.1.2h.1v.2h.1v.1l.1.1zm.3-.7v.4h-.1v.2h-.1v.1h-.1v-.1h.1v-.1h.1zm.3-5.1-.1.2v.3l-.1.1v.3l-.1.2v.7l-.1.1v2.9l.1.2v-.4l-.1-.2v-3.3l.1-.2v-.4l.1-.2.1-.2zM13 21l-.1-.2v-2.5l.1-.2v-.2h.1v-.2l.1-.1v-.1l.1-.1v-.1l.2-.1V17l.1-.1v-.1h.2v-.1l.1-.1h.1-.1l-.1.2-.2.1v.1l-.1.1-.1.2-.1.1v.1l-.1.1v.1l-.1.2-.1.2v.4l-.1.2zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m13 21.6-1-.3q0 1.4.4 3.5v3q1.5-.3.8-3.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "m12.1 21.3.9.3zm.3 3.5v-.4l-.1-.1v-.4l-.1-.1V23H12v-1.7 1.9l.1.2v.6l.1.2v.4zm0 3v-3 .6l.1.1v2l-.1.1zm.8-3.7v.2l.1.2v.4l.1.2v1.7h-.1v.2l-.1.2-.1.1v.1H13l-.1.1v.1h-.2l-.1.1h-.2.3v-.1h.2v-.2l.1-.1.1-.2.1-.2v-.2h.1v-2.4zm-.2-2.5v1.6l.1.1v.4l.1.1v.2-.4H13v-.8l-.1-.1zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "M12.7 24.2v.5h.1V26v-1.4l-.1-.1zm-.2-2.3v.8h.1v.9h.1v.6-.7h-.1v-1.1l-.1-.1V22m0 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m13 16.3.5.1-.2 1q-.3 1.7-.2 3.8.1.8.4 1.3-1-.2-1-1.8a9 9 0 0 1 .1-3.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "M13.5 16.4H13v-.1zm-.1 1v-.8h.1v-.1.6l-.1.1zm-.2 3.8v-.1l-.1-.2v-2.6l.1-.1v-.5l.1-.1v-.2.8l-.1.2v1.2l-.1.2zm.3 1.3v-.1h-.1v-.2l-.1-.1v-.4h-.1v-.5.6l.1.1v.3h.1zm-1-1.8v.9h.1v.2h.1v.2h.1v.1h.1v.1h.1l.1.1h.1l.1.1h.1-.3l-.1-.1-.1-.1-.1-.1-.1-.1v-.1l-.1-.1v-.3l-.1-.1zm0-3.1v.6h-.1v2.5-.8l-.1-.1V18h.1zv-.1m.5-1.3v.3h-.1v.4h-.1v.3h-.1V17l.1-.1v-.3h.1zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m12.6 16.5.3.3v.8l-.3 1c0 1.1 0 2.6.3 3.6q-1-.2-1-1.8 0-1.4.3-3.2 0-.4.4-.7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "m12.9 16.8-.3-.3zm0 .8v-.7.8m-.3 1V18h.1v-.3h.1v-.2.5l-.1.1v.4m.3 3.6-.1-.1v-.3l-.1-.1v-.4l-.1-.1v-2.6 2.8h.1v.4h.1zm-1-1.8.1.1v.7l.1.1v.2l.1.1v.1h.1v.1h.1v.1h.2v.1h.2-.3l-.1-.1h-.1v-.1l-.1-.1v-.1l-.1-.1v-.3H12zm.3-3.2v.4l-.1.2v.9l-.1.1v1.5-2.7l.1-.2V17m.4-.8v.1h-.1v.2h-.1v.3h-.1v-.3h.1v-.1zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M14.2 17.3h-.6l-.2 1.1q0 .6.2 1 .3-.1.4-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "m13.6 17.2.6.1zm-.2 1.2v-.6l.1-.1v-.4h.1v.6h-.1zm.2 1v-.1h-.1V19l-.1-.1v-.5.6l.1.1zm.4-.8v.7h-.1v.1h-.1l.1-.1v-.1l.1-.1v-.2l.1-.1zm.2-1.2v1H14v.2-1.2zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15.8 18.6h-.6v1q0 .5.3.8.2-.1.3-.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "M15.2 18.6h.6zm0 1v-1zm.2.8-.1-.1v-.4h-.1v-.2.3l.1.1v.2zm.4-.7v.4h-.1v.2h-.1v.1h-.1v-.1h.1V20h.1v-.3m0-1v-.1 1.1-1.1m0-.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16.3 18.9h-.5v1q0 .4.3.8.2-.2.3-.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "M15.8 18.9h.5zm0 1v-1 .9m.3.8-.1-.1v-.1l-.1-.1v-.5.6h.1zm.3-.7v.4h-.1v.1l-.1.1-.1.1v-.1h.1v-.2h.1V20m0-1.2V20zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15.2 18.3h-.5l-.1 1q0 .5.2.8.2-.1.4-.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "M14.7 18.3h.5zm0 1v-1h.1zm0 .8v-.4h-.1v-.4.5l.1.1zm.4-.7v.5H15v.1h-.1v.1h-.1V20h.1v-.1h.1v-.3h.1zm.1-1v1zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m14.7 17.8-.6-.3a5 5 0 0 0 0 2.2q.3 0 .5-.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "m14.2 17.5.5.2zm0 2.2H14v-2.1h.1v-.1zm.4-.7v.3l-.1.1v.1h-.1v.1h-.1v.1h-.1l.1-.1v-.1h.1v-.1l.1-.1zm.1-1.2V19h-.1zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#edb92e",
    stroke: "#21231e",
    strokeWidth: 0.1,
    d: "M14.9 31.2q.7.2.4-1.3c-.3-.6-1.4-.3-.8.5h.1q0-.3.2-.3c.5.1.5 1 0 .8v.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#edb92e",
    stroke: "#21231e",
    strokeWidth: 0.1,
    d: "M15.4 28.4q0 .3-.3.5t0 .7l.2.6v.7l-.1.3.1.3.1.1h.1l.1-.1q.3-.2.2-.3l-.2-.3v-.7l.3-.6q.2-.4 0-.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#edb92e",
    d: "M15.2 30.5h.5l.2.1q0 .2-.2.2h-.5l-.1-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "M15.7 30.5h-.5zm.2.1h-.1v-.1zm-.2.2v-.1h.1-.1m-.5 0h.5zm-.2-.2v.1h.1v.1H15v-.1m.2-.2H15v.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16.2 25.7v-.4q-.4-.2-.9.4-.2.6-.8 1.1.8.2 1.1-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "M16.2 25.3v.4zm-.8.4v-.2h.1v-.1h.1v-.1h.3v-.1h.3-.4v.1h-.1l-.1.1-.1.1zm-.8 1.1v-.1h.1v-.1h.1v-.1h.1v-.1l.1-.1v-.1l.1-.1.1-.1v-.2h.1v-.1.3h-.1v.2H15v.2l-.1.1-.1.1v.1zm1-.3h-.1v.1h-.2v.1h-.7.7v-.1h.1v-.1zm.6-.8-.1.1v.1H16v.1h-.1v.1h-.1v.2h-.1v.1h-.1v-.1h.1v-.1l.1-.1V26h.2v-.1zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m16.6 25.8-.6-.2-.4.9q-.1.5 0 .8l.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "m16 25.6.6.2zm-.4.9v-.2h.1V26h.1v-.3h.1v-.1l.1-.1v.2l-.1.1v.1h-.1v.2h-.1v.2m0 .8v-.8h.1zm.5-.5v.2H16v.1h-.1v.1h-.1l-.1.1h-.1.1V27h.1l.1-.1.1-.1zm.5-1v.2h-.1v.2h-.1v.3h-.1v.2h-.1v.1-.3h.1V26h.1v-.3zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16.7 25.8h-.5l-.2.9v.9q.4-.2.6-.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "M16.2 25.7h.5v.1zm-.2 1v-.8h.1v-.1.7zm0 .8v-.8zh.1m.5-.6v.3l-.1.1v.1h-.1l-.1.1H16h.1v-.1h.1v-.1h.1V27h.1zm.2-1.1v.9l-.1.1v.1-1.1zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16.8 25h.3q.4.3.2 1l-.4 1.3q-.6-.4-.4-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "M17.1 25h-.3zm.2 1v-.8h-.1V25h.1v.2h.1v.7m-.4 1.3v-.7h.1v-.2h.1v-.2l.1-.1h.1v.1l-.1.1v.2H17v.6h-.1v.3m-.4-1v.4l.1.1v.1l.1.1.1.1v.1l-.1-.1V27h-.1v-.2h-.1v-.6m.3-1.3v.6l-.1.1v.3l-.1.1v.1h-.1V26l.1-.1v-.3l.1-.1V25zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m17 24.8-.6-.2-.4 1v.8l.6-.5.3-1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "m16.4 24.6.6.2zm-.3 1V25h.1v-.2h.1v-.3h.1v.3h-.1v.2h-.1v.3H16zm-.1.8v-.8zm.6-.5v.1h-.1l-.1.1h-.1v.1h-.1v.1H16h.1l.1-.1h.1v-.1h.1V26h.1zm.3-1v.5h-.1v.3h-.1v.2-.5h.1V25zm0-.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m16.6 24.4-.1-.7-.5.4v.1l-.2.4q-.2.8-.6 1.2.7 0 1-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "m16.5 23.7.1.7zm-.5.4.1-.1v-.1h.1v-.1h.1v-.1h.1v.1h-.1v.1h-.1v.1zm0 .2v-.1h.1m-.2.3v-.3h.1v.2zm-.6 1.2v-.1h.1v-.2h.1v-.1l.1-.1V25h.1v-.3h.1v-.2.4l-.1.1v.2h-.1v.1l-.1.1v.1h-.1zm1-.5H16v.2h-.1l-.1.1h-.2l-.1.1h-.3.4v-.1h.2v-.1h.1v-.1h.1v-.1zm.4-.9v.2h-.1v.2h-.1.1v-.2h.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#edb92e",
    stroke: "#21231e",
    strokeWidth: 0.1,
    d: "M22.2 26q.1-.1.8.5l.8 1.3.3.2h.7q.4-.2.4 0 0 .4-.2.3h-.8l.8.2q.3.1.1.5-.3.2-.4 0c0-.2-.6-.4-.7-.6l.5.8q.2.1 0 .5h-.3q-.4 0-.3-.3l-.2-.8-.1-.2c0-.2-.6-.4-.7-.3q-.4.1-.4-.2l.2-.4.3.2.3.2-.6-.7q-.6-1-.5-1.2Zm-.1 5.2q.7.2.4-1.3c-.2-.6-1.4-.3-.7.5q0-.3.3-.3c.4.1.5 1 0 .8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#edb92e",
    stroke: "#21231e",
    strokeWidth: 0.1,
    d: "M25.2 28.2h.3q0-.4-.4-.3l-.1.2zm-2.6-.2q-.3-.3-.4-.1H22q.3-.6.6-.2l.1.1zm1.5 1.5.1-.3.2.2q.3.4 0 .7h-.2zm.8-.6.2.3q.3-.7-.3-.5v.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "M23.5 27.6v.1h-.1v.1zm-.3 0h.1zm.2-.2v.2h-.1.1zm-.3 0v.1h.2v-.1zm.1-.2v.2zm-.3 0v.1h.2v-.1h.1-.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "M23 27v.1l-.1.1v.1-.1h.1zm-.4 0v.1h.1V27h.2-.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "M22.8 26.8v.2h-.1v.1-.1h.1zm-.4 0h.3v-.1h-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#21231e",
    strokeWidth: 0.1,
    d: "m20 25.8.4-.2q.4.3 0 1l-.6 1.2q-.5-.6-.2-1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#21231e",
    strokeWidth: 0.1,
    d: "m19.6 25.5.4-.3c.2.2.6.6.3 1q-.7.7-.9 1.2-.4-.5-.2-1l.4-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#21231e",
    strokeWidth: 0.1,
    d: "m20.6 25.3.4-.2q.4.2 0 1-.4.5-.6 1.2-.5-.6-.2-1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M22.5 20.8v3.4l.4.7q.3-.3.3-.8V21q-.4-1.1-.7-.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "M22.6 24.2v-3.4h-.1v3.4m.4.7h-.1v-.1h-.1v-.1l-.1-.1v-.3h-.1v-.1.4h.1v.2h.1v.1h.1m.2-.8v.8-.2h.1v-.3h.1V24m0-3.2V24zm-.7 0v-.2h.1v-.2h.1v-.1h.2v.1l.1.1v.1l.1.1v.2h.1v-.2l-.1-.1v-.1l-.1-.1v-.1h-.4v.3h-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M24.2 20.2v3.6a8 8 0 0 1-.5 2.5c-.6-.2-.7-1.5-.6-2.7v-3.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "m24.3 23.8-.1-3.6zm-.6 2.5v-.1h.1v-.3l.1-.1v-.2l.1-.2v-.2l.1-.2v-.2l.1-.2V24h.1v-.3.5l-.1.1v.4l-.1.1v.3l-.1.1v.3l-.1.1v.3h-.1v.2zm-.6-2.7v1.9l.1.2v.1h.1v.2h.1v.1h.1v.1l.1.1h.1l-.1-.1h-.1V26l-.1-.2-.1-.2v-.3h-.1v-1.8m0-2.6H23v.6h.1v2V21m0-.8v.7H23v.1-.8m1 0h-1 1.2m.1 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M24.8 20.8v3.5a8 8 0 0 1-.8 2.5c-.5-.4-.4-2.2-.3-2.7v-3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "M24.8 24.3v-3.5zm-.8 2.5v-.2h.1v-.2l.1-.1V26l.1-.1v-.2l.1-.1v-.3l.1-.1V25l.1-.2v-.4.7h-.1v.4h-.1v.2l-.1.2v.2h-.1v.2l-.1.1v.2zm-.3-2.7v.1l-.1.1v1.9l.1.1v.1l.1.1v.1h.1v.1h.1l-.1-.1v-.1l-.1-.1v-.3h-.1V24m0-2.5V24v-.8h.1v-1.6m0-1v1-.8h.1zm1.1.2h-.5v-.1h-.5.9zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M25.3 21.6h-1c.2.4.1 1.6 0 2.5-.2.9-.4 3 .5 3.6.5-1.2.1-2.3.4-3.3q.3-1.5.1-2.8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "M24.4 21.6h1zm-.2 2.5v-.2h.1v-.7l.1-.2v-1.4 1.8h-.1v.7m.6 3.6-.1-.2-.1-.1V27h-.1v-.3l-.1-.1V24v.9l-.1.2v1.5l.1.1v.3h.1v.2h.1v.2h.1l.1.1zm.4-3.3v.2H25v2.2l-.1.1v.3l-.1.2-.1.2v.1-.2l.1-.1v-.1l.1-.1v-.8l.1-.1v-1.8zm.1-2.8v2.5h-.1v.3-.4l.1-.2V23l.1-.2v-1.2m0 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m21.8 20.2.1 3.3q0 .6.4.7.3-.3.3-.8l-.2-3.1q-.4-1.2-.6-.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "M22 23.5v-1.1l-.1-.1v-1.6l-.1-.2v-.3 2.9l.1.1v.3m.3.8v-.1h-.1V24H22v-.4.4h.1v.1h.1zm.3-1v.4h-.1v.3h-.1v.2-.2h.1v-.6m-.1-3v3-3.1m-.8-.1v-.3h.1v-.1h.3v.2h.1v.2l.1.1V20H22v-.1l-.1-.1-.1-.1h-.2v.2h-.1zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M23.4 18.1v2.8l-.2 1a1 1 0 0 1-.4-.8v-2.4l.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "M23.4 20.9V18zm-.2 1v-.2h.1v-.2h.1v-.6.6l-.1.1v.1zm-.4-.8v.5h.1v.1h.1v.1h.1v.1-.1H23v-.2h-.1v-.2l-.1-.1zm0-2.4V21zm.5-.5v.1H23v.2h-.1l-.1.1h.2v-.1h.1v-.1h.1zm.1-.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m22.7 18.6-.2 3.3-.4-.7v-2q.3-.1.7-.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "M22.7 21v-2.4zm-.2.9.1-.1v-.2h.1V21v.5h-.1v.2zm-.4-.7v.3h.1v.2h.1v.1h.1v.1-.1l-.1-.1v-.1h-.1v-.4m0-2H22v1.9h.1zm0 0H22m.6-.6h-.1v.1h-.1v.1h-.1v.1h-.1v.1h-.1l-.1.1h.1l.1-.1h.2v-.1h.1v-.1h.1zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m23.3 18 .6-.9c.2.5.3 3.7.1 4q0 .5-.2.8-.4-.2-.4-.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "m24 17.1-.7 1zm0 4 .1-.1v-3.7H24v-.1 2.3l.1.1V21m-.2.8.1-.1v-.2h.1V21v.4l-.1.1v.1zm-.4-.7v.4h.1v.1l.1.1h.1v.1-.1h-.1v-.1h-.1V21m0-3.2v1.4h.1v1.7-3m0 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M24.6 20v1q0 .6-.2 1-.3-.2-.4-.8.1-2-.2-4l.6-.3q.5 2.5.2 3.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "M24.6 21v-.9 1m-.2 1V22h.1v-.3h.1V21v.5l-.1.1v.1h-.1zm-.3-.8v.5h.1v.1h.1v.1h.1-.1v-.1l-.1-.1v-.1l-.1-.1zm-.3-4v.8l.1.2v1l.1.2v1.8V18l-.1-.2v-.4zm.5-.3h-.1l-.1.1h-.2v.1h-.1v.1h.1V17h.2zm.3 3.1V18l-.1-.1v-.5l-.1-.1V17h-.1v.4l.1.2v.5l.1.2v.8l.1.1zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m25.3 21-.2.6q0 .5-.4.9l-.3-.7c.3-2.1.2-3.5-.2-5.2q1.6 1 1 4.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "m25.1 21.6.2-.6zm-.4.9v-.1h.1v-.1l.1-.1V22h.1v-.4h.1v.1l-.1.1v.2h-.1v.1h-.1v.2zm-.3-.7v.4l.1.1v.1h.1v.1h.1v-.1h-.1v-.1h-.1v-.5m-.3-5.1.1.2v.3l.1.1v.5l.1.1v.7l.1.2v2.7l-.1.2v-.6l.1-.2V18l-.1-.2v-.3l-.1-.1V17l-.1-.2zm1.1 4.3.1-.2v-2.5l-.1-.2v-.2H25v-.2l-.1-.1v-.1l-.1-.1-.1-.1v-.1l-.1-.1-.1-.1v-.1h-.2v-.1l-.1-.1h-.1.1l.1.2.2.1v.1l.1.1.1.2v.1l.2.1v.2l.1.2v.2l.1.2v.2l.1.2V21m0 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m25.2 21.6.9-.3q.1 1.4-.3 3.5-.2 2 0 3-1.4-.3-.8-3.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "m26 21.3-.8.3 1-.3zm-.2 3.5v-.4l.1-.1v-.5l.1-.1V23l.1-.1v-1.7 1.9l-.1.2v.5l-.1.1v.6h-.1zm0 3v-1.3h-.1V25l.1-.1v-.2.5l-.1.1v2.2zM25 24l-.1.2v.6l-.1.2v1.7l.1.2.1.2.1.1v.1h.1l.1.1v.1h.2l.1.1h.2-.3v-.1h-.1l-.1-.2-.1-.1-.1-.2-.1-.2v-.2h-.1v-.8l-.1-.1v-1.1l.1-.2v-.2zm.2-2.5v1.6H25v.5l-.1.1v.2-.4h.1v-.9h.1zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "M25.4 24.2v.4l-.1.1V26v-1.5h.1zm.3-2.3v.8h-.1v.9h-.1v.4l-.1.2V24l.1-.1v-.5l.1-.2V22zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m25.2 16.3-.6.1.3 1q.3 1.7.2 3.8-.1.8-.4 1.3 1-.2 1-1.8a9 9 0 0 0-.1-3.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "M24.7 16.4h.5v-.1zm.1 1v-.8h-.1v-.1.7h.1zm.2 3.8v-.1l.1-.2v-2.6l-.1-.1v-.5l-.1-.1v-.2 1l.1.1zm-.3 1.3v-.1h.1v-.2l.1-.1v-.4h.1v-.5.6h-.1v.3l-.1.1v.2zm1-1.8v.9h-.1v.2h-.1v.2h-.1v.1h-.1v.1h-.1l-.1.1H25l-.1.1h-.2.4l.1-.1v-.1h.1l.1-.1V22l.1-.1v-.1l.1-.1v-.2l.1-.1zm-.1-3.1v.6l.1.2v2.3-2.9zm-.4-1.3.1.1v.2l.1.1v.3l.1.1v.2h.1V17h-.1v-.4h-.1v-.3l-.1-.1zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m25.6 16.5-.3.3v.8l.3 1c0 1.1 0 2.6-.3 3.6q1-.2 1-1.8 0-1.4-.3-3.2 0-.4-.4-.7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "m25.3 16.8.3-.3zm0 .8v-.7.8m.3 1v-.4l-.1-.1v-.3h-.1v-.2.6h.1v.4m-.3 3.6V22l.1-.1v-.2l.1-.1v-.4l.1-.1v-2.6 2.8h-.1v.4h-.1v.4m1-1.8v.9l-.1.1v.2l-.1.1v.1H26v.1h-.1l-.1.1h-.1v.1h-.2.3l.1-.1h.1v-.2h.1v-.2l.1-.1v-.2l.1-.2zm-.3-3.2v.4l.1.2V19l.1.1v1.3-2.7l-.1-.2v-.3m-.4-.8v.1h.1v.1l.1.1v.1h.1v.3h.1v-.3H26v-.1l-.1-.1-.1-.1zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M24 17.3h.6l.2 1.1q0 .6-.2 1-.3-.1-.4-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "m24.6 17.2-.6.1zm.2 1.2v-.6h-.1v-.4l-.1-.1v.6l.1.1v.4m-.2 1v-.1h.1v-.4h.1v-.5.6l-.1.1v.2zm-.4-.8v.5l.1.1v.1h.1v.1h.1l-.1-.1v-.1h-.1v-.3h-.1zm-.2-1.2v1h.1v.2-1.1zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M22.4 18.6h.6v1q0 .5-.3.8l-.3-.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "M23 18.6h-.6zm0 1v-1zm-.2.8v-.2h.1v-.6h.1v.3l-.1.1v.2h-.1zm-.4-.7v.4l.1.1v.1h.1v.1h.1v-.1h-.1V20h-.1v-.3m0-1v-.1 1.1-1.1m0-.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M21.9 18.9h.5v1q0 .4-.3.8l-.3-.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "M22.4 18.9h-.5zm0 1v-1 .9m-.3.8v-.1h.1v-.2h.1v-.5.5l-.1.1zm-.3-.7v.4h.1v.2h.1v.1h.1v-.1H22v-.2h-.1V20m0-1.2V20zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M23 18.3h.5l.1 1q0 .5-.2.8l-.4-.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "M23.5 18.3H23zm0 1h.1v-1h-.1zm0 .8v-.5h.1v-.3.5h-.1v.2l-.1.1m-.5-.7v.3h.1v.2h.1v.1h.1v.1h.1l-.1-.1v-.1h-.1v-.3H23zm0-1v1zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m23.5 17.8.5-.3a5 5 0 0 1 0 2.2l-.4-.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "m24 17.5-.5.2zm0 2.2h.1v-.8h.1v-1.1l-.1-.1v-.1 2.1m-.4-.7v.4h.1v.1h.1v.1h.1v.1h.1l-.1-.1-.1-.1v-.1l-.1-.1V19m-.1-1.2V19h.1v-1.1zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#edb92e",
    stroke: "#21231e",
    strokeWidth: 0.1,
    d: "M23.3 31.2q-.7.2-.4-1.3c.3-.6 1.4-.3.8.5h-.1q0-.3-.2-.3c-.5.1-.5 1 0 .8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#edb92e",
    stroke: "#21231e",
    strokeWidth: 0.1,
    d: "M22.7 28.4q.1.3.4.5t0 .7l-.2.6v.7l.1.3-.2.3v.1h-.1l-.1-.1q-.3-.2-.2-.3l.2-.3v-.7l-.3-.6q-.2-.4 0-.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#edb92e",
    d: "M23 30.5h-.5l-.2.1q0 .2.2.2h.5l.1-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "M22.5 30.5h.5zm-.2.1.1-.1zm.2.2v-.1h-.1.1m.5 0h-.6zm.1-.2H23v.1h.1zm-.1-.2h.1v.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M22 25.7v-.4q.4-.2.8.4l.8 1.1q-.7.2-1-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "M22 25.3v.4zm.8.4v-.2h-.1v-.1h-.1v-.1h-.3v-.1H22h.4v.1h.1l.1.1v.1h.1zm.8 1.1v-.1h-.1v-.1h-.1v-.1h-.1v-.1l-.1-.1v-.1H23v-.3l-.1-.1v-.1.3h.1v.2h.1v.1h.1v.2h.1l.1.1v.1zm-1-.3h.1v.1h.2v.1h.7-.7l-.1-.1v-.1zm-.6-.8.1.1v.1h.1v.1h.1v.1l.1.1v.1h.1v.1-.2h-.1V26h-.2v-.1l-.1-.1m0 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m21.6 25.8.6-.2.4.9q.1.5 0 .8l-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "m22.1 25.6-.5.2zm.5.9v-.2h-.1V26h-.1v-.2l-.1-.1v-.1l-.1-.1v.2l.1.1v.1h.1v.2l.1.1v.1m0 .8v-.8h-.1v.8m-.5-.5v.2l.1.1h.1v.1h.1v.1h.2-.1l-.1-.1-.1-.1-.1-.1zm-.5-1v.2h.1v.2l.1.1v.2l.1.1v.1l.1.1v-.3h-.1V26h-.1zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M21.5 25.8h.5l.2.9v.9a1 1 0 0 1-.6-.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "M22 25.7h-.5v.1zm.2 1V26l-.1-.1v-.1.8zm0 .8H22l.1-.1v-.7.7zm-.5-.6v.3l.1.1v.1h.1v.1h.2-.1v-.1h-.1v-.1h-.1V27h-.1zm-.2-1.1v1h.1v.1-1zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M21.4 25h-.3q-.4.3-.2 1 .4.7.4 1.3.5-.4.4-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "M21 25h.4zm-.1 1v-.8l.1-.1h-.1v.2h-.1v.7m.4 1.3v-.6l-.1-.1v-.2H21V26h-.1v.1l.1.1v.2h.1v.2h.1v.4h.1v.3m.4-1v.4l-.1.1v.1h-.1v.1l-.1.1v.1-.1h.1V27h.1v-.2h.1v-.6m-.3-1.3v.7h.1v.4h.1v.1-.5l-.1-.1v-.4h-.1zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m21.2 24.8.6-.2.4 1v.8l-.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "m21.8 24.6-.6.2zm.3 1V25H22v-.2h-.1v-.2l-.1-.1v.3h.1v.2h.1v.3h.1zm.1.8v-.8zm-.6-.5v.1h.1v.1h.1l.1.1h.1v.1h.2-.2v-.1h-.1v-.1h-.1V26h-.1zm-.3-1v.5h.1v.3l.1.1v.1-.5h-.1V25zm0-.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m21.6 24.4.1-.7.5.4v.1l.2.4q.1.8.6 1.2-.6 0-1-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "m21.7 23.7-.1.7zm.5.4L22 24v-.2h-.1v-.1h-.1v.1h.1v.1h.1v.1zm0 .2v-.1h-.1m.2.3v-.3h-.1v.2zm.6 1.2v-.1h-.1v-.1l-.1-.1v-.1l-.1-.1V25h-.1v-.3h-.1v-.2.5h.1v.2h.1v.2h.1v.1h.1zm-1-.5h.1v.1h.1v.1h.1l.1.1h.2l.1.1h.3-.4v-.1h-.2v-.1h-.1v-.1h-.1v-.1H22zm-.4-.9h.1v.2h.1v.2h.1v.2h.1-.1v-.2h-.1v-.2h-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#21231e",
    strokeWidth: 0.1,
    d: "M21.5 18.4h.2l-1-1c-.3-.5.2-1.5.4-2q.7-.5 1-1.3c0-.4-.9-.3-1.5 0l-1.1.4q-.2.6.3.4-.6 1-.7 2.3 0-1.4-.7-2.3.4.1.3-.4l-1.1-.4c-.6-.2-1.5-.4-1.5 0q.3.9 1 1.3c.2.5.7 1.5.3 2l-1 1h.3l-.6.2-.9-1.1q-1.2-1.4-1-2.2c.1-.6.9-1.3-.1-1.2s-1.8 1.4-2 3l-.2 1.5q.7-.3.9-.6l-.2.6q.8 0 .9-.6l.1-.4h.6l1 1.3q.6.9 1 1l.1-.5H22l.1.5q.4-.1 1-1c.4-.5 1-1.1 1-1.3h.6l.1.4q.2.6.9.6l-.2-.6q.2.3 1 .6l-.3-1.5c-.2-1.6-1-2.9-2-3s-.2.6 0 1.2q.1.9-1 2.2l-1 1.1-.6-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#edb92e",
    d: "M17.2 15.9h-.8q-1 0-1-.5.3.5.8.3l.8-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "M16.4 16h.6v-.1h.2-.7m-1-.6v.2h.1v.1h.1v.1h.3v.1h.5-.8v-.1h-.1v-.1h-.1zm.8.3h-.6l-.1-.1-.1-.1-.1-.1h.1v.1h.1l.1.1h.2v.1zm.8-.2H17l-.1.1h-.3l-.1.1h-.2.3l.1-.1zm.3.4v-.2H17v-.1h.1v.2m-.3-1.4h-.3v-.1h-.4v-.1h.6zm.4 0H17v-.1h.3m.6.4h.4zm-1.1 0h-.1v-.1h-.1v-.2h-.1v-.1l.1.1v.1h.1v.1zm.4-.3v.2H17v.1h-.2.1v-.1h.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "M16.8 14.7h-.1v-.3h.2zm.7 3.5v.1h-.1v.1h-.9.9zm.2-.1h-.1m-.1.4v-.1l.1-.1V18l.1-.1v.5zm.7-.4v.2H18v.1h-.1l-.1.1h-.2v.1-.1h.2v-.1h.2v-.1zm.2.3v-.3h-.1v-.4.4h.1v.2zm.3-.5v.3h-.1v.1h-.1v.1h-.1v-.1h.1v-.1l.1-.1zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#edb92e",
    d: "M15.7 14.1q-1 .2 0 1.3.2.1.2 0 .1-.5.5-.2l.3.1c.4.3.8.6.2.6h-.7l.2.3.9-.1c.6.1-1-1.7-1-1.8q-.1-.5-.6-.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "M15.7 15.4V15h-.1v-.2h-.1v-.5h.1v-.1h.3l.1-.1h-.2v.1h-.1l-.1.1-.1.1v.4h.1v.2h.1v.1h.1v.1h.1zm.2 0h-.2.1m.5-.2h-.1V15H16v.2h-.1v-.1h.1V15h.3m.4 0h-.4zm.1.7h.2v-.3h.1l-.1-.1-.1-.1v-.1l.1.1h.1v.1h.1v.1h.1v.2H17m-.6 0h.6zm1 .2h-.6v.1h-.3.4v.1h.5m-1-1.8.1.2h.1v.1l.1.1.1.1.1.2.1.1.1.1v.1h.1v.2h.1v.3h-.1v-.4H17V15l-.1-.1h-.2l-.1-.1-.1-.1-.1-.1v-.1h-.1v-.1zm-.6-.2h.5v.3-.3h-.2zm.6.6v-.1h-.1v-.2.1h.1v.1zm-3.5 4v-.4l.1-.2v-.2h.1v-.2l.1-.1v-.2l.1-.1V17l.1-.1v-.2l.1-.1.1-.2v-.1h.1v-.1l.1-.1h.1v.1h-.1v.1h-.1v.2l-.1.1v.1l-.1.1v.2H13v.4l-.1.2v.2l-.1.2v.2h-.1v.3zm.2 3.6v-.4H13v-.5l-.1-.1v-2.5 2.8l.1.1v.3h.1zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#edb92e",
    d: "M21 15.9h.7q1 0 1.2-.5-.4.5-1 .3l-.7-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "M21.7 16h-.5v-.1H21zm1.2-.6-.1.1v.1h-.1v.1h-.1v.1h-.3v.1h-.6.9v-.1h.1v-.1l.1-.1zm-.9.3h.6v-.1h.1l.1-.1v-.1.1h-.1l-.1.1h-.2v.1zm-.8-.2h.1l.1.1h.3l.1.1h.1-.2l-.1-.1h-.4m-.3.4.1-.1v-.1h.1v-.1H21v.2m.3-1.4h.3v-.1h.4v-.1h-.6zm-.4 0h.4v-.1H21m-.6.4H20zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "M21.3 14.8h.1v-.1h.1v-.2h.1v-.1h-.1v.2h-.1v.1zm-.3-.3v.2h.1v.1h.2-.1v-.1H21z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "M21.4 14.7h.1v-.3h-.2zm-.7 3.5v.1h.1v.1h.9-.9zm-.2-.1h.1m.1.4v-.1h-.1V18h-.1v-.1.5zm-.7-.4v.2h.2v.1h.1l.1.1h.2v.1-.1h-.2v-.1h-.2v-.1H20zm-.2.3.1-.1v-.2h.1v-.4.4h-.1v.2zm-.3-.5v.3h.1v.1h.1v.1h.1v-.1h-.1v-.1h-.1V18zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#edb92e",
    d: "M22.5 14.1q1 .2 0 1.3-.2.1-.2 0-.1-.5-.5-.2l-.3.1c-.4.3-.8.6-.2.6h.7l-.2.3-.9-.1c-.6.1 1-1.7 1-1.8q.1-.5.6-.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "m22.5 15.4.1-.1v-.1h.1V15h.2v-.2l.1-.1v-.4h-.1v-.1h-.3l-.1-.1h.2v.1h.1l.1.1.1.1v.4h-.1v.1l-.1.1v.1h-.1v.1h-.1zm-.2 0h.1zm-.5-.2V15h.2v.1h.1v.1h.1v-.1h-.1V15h-.3m-.4 0h.4zm-.1.7H21v-.3h.1v-.1h.1v-.1h.1v-.1l-.1.1h-.1v.1H21v.3zm.6 0h-.6.8m-.1.3h.1v.1zm-.9-.1h.6v.1h.3zm1-1.8-.1.2h-.1v.1l-.1.1-.1.1-.1.2H21v.1l-.1.1v.1h-.1v.2h-.1v.3h.1-.1v-.2l.1-.1v-.1l.1-.2.2-.1v.1h.1l.1-.2.1-.1v-.1h.1l.1-.1v-.1h.1v-.1zm.6-.2H22v.2h-.1v.1-.1h.1V14h.4zm-.6.6h.1v-.1h.1v-.1h.1v-.2.1h-.1v.1h-.1zm3.5 4v-.4h-.1v-.4h-.1v-.2l-.1-.1v-.1l-.1-.1V17H25v-.2l-.1-.1-.1-.2-.1-.1v-.1h-.1v-.1h-.1v.1h.1v.1h.1v.2l.1.1v.1l.1.1v.2h.1v.2h.1v.4h.1v.2l.1.2v.2l.1.1zm-.2 3.6v-.4h.1v-.6l.1-.1v-2.4 2.6l-.1.2v.4h-.1zm-6.7-4.5v.4l.1.1v.1l.1.1v.1h.1v.1h.2v-.2h.1v-.2h.1V18l.1-.1v-.1.2h-.1v.3h-.1v.2h-.1v.1H19v-.2h-.1v-.2h-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c6363c",
    d: "M22 18.8v4.8q0 1.3-.8 2.2a3 3 0 0 1-4.2 0q-.9-1-.9-2.2v-4.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#21231e",
    strokeWidth: 0.1,
    d: "M20.1 21.2v-1.7c.4-.1 1.3-.5 1.4.3 0 .4-.5.6-.6.3v-.3q.3 0 .2.2c.4-.3-.3-.7-.6-.1l.1.4-.1.5c.3.6 1 .1.6 0H21q-.2 0-.1-.2c.1-.3.6-.1.6.3 0 .8-1 .4-1.4.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#21231e",
    strokeWidth: 0.1,
    d: "M22 21.7V23h-2.3v3.6h-1.2V23H16v-1.3h2.4v-3h1.2v3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#21231e",
    strokeWidth: 0.1,
    d: "M18 21.2v-1.7c-.3-.1-1.2-.5-1.3.3 0 .4.5.6.6.3v-.3q-.3 0-.3.2c-.3-.3.4-.7.7-.1l-.1.4.1.5c-.3.6-1 .1-.7 0h.2q.2 0 .1-.2c-.1-.3-.6-.1-.6.3 0 .8 1 .4 1.4.3Zm0 4v-1.7c-.3-.1-1.2-.5-1.3.3 0 .4.5.6.6.3v-.3q-.3 0-.3.2c-.3-.3.4-.7.7-.1l-.1.4.1.5c-.3.6-1 .1-.7 0h.2q.2 0 .1-.2c-.1-.3-.6-.1-.6.3 0 .8 1 .4 1.4.3Zm2.1 0v-1.7c.4-.1 1.3-.5 1.4.3 0 .4-.5.6-.6.3v-.3q.3 0 .2.2c.4-.3-.3-.7-.6-.1l.1.4-.1.5c.3.6 1 .1.6 0H21q-.2 0-.1-.2c.1-.3.6-.1.6.3 0 .8-1 .4-1.4.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21231e",
    d: "M16 18.7V24l.1.2v.4h.1v.2l.1.1v.2h.1v.2h.1l.1.2.1.1v.1h.1v.1h.1v.1h.1v.1h.1l.1.1.1.1.1.1.2.1.1.1h.1l.1.1h.2l.1.1h.3v.1H20l.1-.1h.2l.1-.1h.1l.1-.1h.1l.1-.1.1-.1.1-.1h.1l.1-.1.1-.2h.1v-.1h.1v-.1l.1-.1v-.1h.1v-.1l.1-.1V25l.1-.1v-.1l.1-.1v-.2l.1-.1v-.3l.1-.2v-5.2zm.2.1H22v5.6l-.1.1v.2h-.1v.2l-.1.2-.1.1v.1h-.1v.1h-.1v.2h-.1v.1h-.1v.1H21v.2h-.2v.1h-.1v.1h-.2v.1h-.2v.1H20v.1h-.3l-.1.1h-1.5l-.1-.1h-.2v-.1h-.1l-.2-.1v-.1h-.1l-.1-.1h-.1V26h-.1v-.1H17v-.2h-.1v-.1l-.1-.1v-.1h-.1v-.1l-.1-.1V25l-.1-.1v-.2h-.1v-.2l-.1-.2V24l-.1-.1v-5.2"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.3 0h53.3v40H.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRs);
export default __webpack_public_path__ + "static/media/rs.8fb0c8da738f855c5ed506e2ccfc91eb.svg";
export { ForwardRef as ReactComponent };